<template>
  <div>
    <v-tabs v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
      <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`" @change="refreshTab()">
        {{ tabitem }}
      </v-tab>
    </v-tabs>
    <v-container grid-list-md class="pa-0 ma-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs-items v-model="tab">
            <v-tab-item :key="0" value="tab-0">
              <v-layout row wrap>
                <v-flex xs12 v-if="lAction === 'view'">
                  <v-flex xs12>
                    <v-layout>
                      <v-flex xs7 v-if="$vuetify.breakpoint.smAndUp && ppmCal.length" class="text-xs-left pb-0 pl-2">
                        <span v-for="(chip, index) in statusChip" :key="index">
                          <v-chip small disabled :class="'caption white--text mx-0 ' + (chip === 'Unscheduled' ? 'grey' : chip === 'Scheduled' ? 'blue' : chip === 'Completed' ? 'green' : 'red')">
                            {{chip}}
                          </v-chip>
                        </span>
                      </v-flex>
                      <v-flex v-else-if="!ppmCal.length" xs7></v-flex>
                      <v-flex xs12 sm5 class="text-xs-right pb-0 pr-2">
                        <span v-for="(chip, index) in chips" :key="index">
                          <v-chip small @click="returnEnableChip(chip)" :class="enableChip === chip ? 'primary white--text px-1' : 'px-1'">
                            <span style="cursor: pointer;">{{chip}}</span>
                          </v-chip>
                        </span>
                      </v-flex>
                      <v-flex xs5 style="margin-top: -15px; margin-left: 20px;">
                        <v-switch
                        v-model="showNonEq"
                        label="Show Nonequipment"
                        @change="loadPpmList()"
                        class="my-label-text-size"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs5 class="text-xs-right">
                        <v-btn small class="accent" @click="downloadAsPdf">Download As Pdf</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12 sm6 style="margin-top: -30px; margin-left: 10px;">
                      <v-select
                      v-model="filterList.asset_cat_list"
                      label="Filter By Category"
                      :items="catList"
                      item-value="asset_cat_id"
                      item-text="asset_cat"
                      clearable
                      chips
                      multiple
                      hide-details
                      @input="loadPpmList(filterList.asset_cat_list)"
                      dense
                      deletable-chips
                      return-object
                      ></v-select>
                    </v-flex>
                  </v-flex>
                  <!-- Month view -->
                  <v-flex xs12 v-if="enableChip === 'Month'" id="pdf_report">
                    <v-layout row wrap>
                      <v-flex xs2 class="text-xs-left pt-0">
                        <v-btn fab outline small color="info" @click="prevMonth()">
                          <v-icon dark>keyboard_arrow_left</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs8 class="text-xs-center pt-3">
                        <span :class="$vuetify.breakpoint.smAndUp ? 'info--text title' : 'info--text .subheading'">{{calViewTitle + ' [Week ' + startingWeekOfMonth + ' - Week ' + endingWeekOfMonth + ']' }}</span>
                      </v-flex>
                      <v-flex xs2 class="text-xs-right pt-0">
                        <v-btn fab outline small color="info" @click="nextMonth()">
                          <v-icon dark>keyboard_arrow_right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-divider></v-divider>
                      <v-sheet height="500">
                        <v-calendar
                        ref="calendar"
                        v-model="start"
                        :now="today"
                        :value="today"
                        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                        color="primary">
                          <template v-slot:day="{ date }">
                            <template v-for="event in eventsMap[date]">
                              <v-menu offset-x>
                                <template v-slot:activator="{ on }">
                                  <div v-on="on"
                                  :class="(handy.formatDBDate(event.sched_dt) >= today) && (event.ppm_status === 'Scheduled') ? 'blue white--text text-xs-center caption' : (handy.formatDBDate(event.comp_dt) && (event.ppm_status === 'Completed') ? 'green white--text text-xs-center caption' : handy.formatDBDate(event.ppm_week_start_dt) && (event.ppm_status === 'Unscheduled') ? 'grey white--text text-xs-center caption' : 'red white--text text-xs-center caption')"
                                  v-ripple style="cursor: pointer; margin-top: 1px; border-radius: 4px;"
                                  v-html="event.freq + (event.asset_cat  ? ' (' + handy.unique(event.asset_category) + ')' : event.noneq_nm.length > 0 ? ' (' + event.noneq_nm.join() + ')' : '') + ' - <strong>' + (event.freq === 'S' ? event.tot_onlyonce : (event.freq === 'W' ? event.tot_weekly : (event.freq === 'BW' ? event.tot_biweekly : (event.freq === 'M' ? event.tot_monthly : (event.freq === 'BM' ? event.tot_bimonthly : (event.freq === 'Q' ? event.tot_quaterly : (event.freq === 'HY' ? event.tot_half_yealy : event.tot_yearly))))))) + '</strong>' ">
                                  </div>
                                </template>
                                <v-card width="400px">
                                  <v-card-title class="py-0 pl-2 primary white--text">
                                    <v-flex xs12 class="pa-0">
                                      <div class="py-2 pr-2 lighten-1 white--text font-weight-bold">
                                        {{ 'Week ' + event.ppm_week + ': ' + ((handy.formatDBDate(event.sched_dt) < today) && (event.ppm_status === 'Scheduled') ? 'Past Due' : event.ppm_status) + ' PPM Activities' }}
                                      </div>
                                    </v-flex>
                                  </v-card-title>
                                  <v-card-text class="py-0 pl-2 pr-0 black--text">
                                    <v-flex xs12 v-for="(ppm, n) in event.ppmList" :key="n">
                                      <v-layout row wrap>
                                        <v-flex xs8 class="py-2">
                                          <div class="font-weight-bold">{{ppm.freq + ' - ' + (ppm.asset_id ? (ppm.asset_cat + ' ' + ppm.asset_name) : ppm.noneq_name)}}</div>
                                          <div>{{ ppm.asset_tag ? ppm.asset_tag : '-' }}</div>
                                          <div>{{ppm.activity_desc}}</div>
                                        </v-flex>
                                        <v-flex xs4 class="pa-0 text-xs-right">
                                          <v-btn class="pa-0 ma-0" icon @click="prepareEdit(ppm, event)"><v-icon small>edit</v-icon></v-btn>
                                          <v-btn class="pa-0 ma-0" icon @click="loadServiceHistory(ppm, event.ppm_week)"><v-icon small>build</v-icon></v-btn>
                                        </v-flex>
                                      </v-layout>
                                      <v-divider v-if="n !== event.ppmList.length - 1"></v-divider>
                                    </v-flex>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </template>
                          </template>
                        </v-calendar>
                      </v-sheet>
                    </v-flex>
                  </v-flex>
                  <!-- Year view -->
                  <v-flex xs12  v-if="enableChip === 'Year'">
                    <v-layout row wrap>
                      <v-flex xs2 class="text-xs-left pt-0">
                        <v-btn fab outline small color="info" @click="prevYear()">
                          <v-icon dark>keyboard_arrow_left</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs8 class="text-xs-center pt-3">
                        <span :class="$vuetify.breakpoint.smAndUp ? 'info--text title' : 'info--text .subheading'">
                          {{ '52 Weeks PPM Schedule (' + calYearViewTitle + ')' + (enabledFilter ? (filteredList ? ' - ' + filteredList : '') : '') }}
                        </span>
                      </v-flex>
                      <v-flex xs2 class="text-xs-right pt-0">
                        <v-btn fab outline small color="info" @click="nextYear()">
                          <v-icon dark>keyboard_arrow_right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="mx-2 mb-2 mt-0">
                      <v-flex xs2 sm1 v-for="(week, i) in endingWeek" :key="i"
                      :style="i < (currentWeek - 1) ? 'background-color: #F8F8F8; border: 1px solid #F0F0F0; cursor: pointer; min-height: 74.2px;' : 'border: 1px solid #F0F0F0; cursor: pointer; min-height: 74.2px;'">
                        <v-menu :close-on-content-click="false" offset-x>
                          <div slot="activator" class="mt-1">
                            <span :style="i === (currentWeek - 1) ? 'border: 1px solid orange; border-radius: 50%; padding: 7px;' : ''">{{i+1}}</span>
                            <div :class="n===0 ? 'mt-2 text-xs-center' : 'text-xs-center'"
                            v-for="(year, n) in ppmCal.filter(rec => rec.ppm_week === (i+1) && (rec.year === calYearViewTitle))" :key="n">
                              <div
                              :class="((year.sched_dt ? handy.formatDBDate(year.sched_dt.split(',')[0]) : handy.formatDBDate(year.sched_dt)) >= today) && (year.ppm_status === 'Scheduled') ? 'blue white--text caption' : (handy.formatDBDate(year.comp_dt) && (year.ppm_status === 'Completed') ? 'green white--text caption' : handy.formatDBDate(year.ppm_week_start_dt) && (year.ppm_status === 'Unscheduled') ? 'grey white--text caption' : 'red white--text caption')"
                              :style="$vuetify.breakpoint.smAndUp ? 'margin: 2px 1px 2px 1px; border-radius: 4px; padding: 2px; width: 75px;' : 'margin: 2px 1px 2px 1px; border-radius: 4px; padding: 2px; width: 49px;'"
                              @click="currentFreq = year.freq, currentStatus = year.ppm_status">
                              {{(year.freq === 'S' ? year.tot_onlyonce : (year.freq === 'W' ? year.tot_weekly : (year.freq === 'BW' ? year.tot_biweekly : (year.freq === 'M' ? year.tot_monthly : (year.freq === 'BM' ? year.tot_bimonthly : (year.freq === 'Q' ? year.tot_quaterly : (year.freq === 'HY' ? year.tot_half_yealy : year.tot_yearly))))))) + ' ' + year.freq + (year.asset_cat ? ' (' + handy.unique(year.asset_category) + ')' : year.noneq_nm.length > 0 ? ' (' + year.noneq_nm.join() + ')' : '')}}
                              </div>
                            </div>
                          </div>
                          <v-card width="400px">
                            <v-card-text class="pa-0 black--text">
                              <div v-for="(year, n) in ppmCal.filter(rec => (rec.ppm_status === currentStatus) && (rec.freq === currentFreq) && (rec.ppm_week === (i+1)) && (rec.year === calYearViewTitle))" :key="n">
                                <v-flex xs12 class="pa-0 primary white--text" v-if="n < 1">
                                  <div class="py-2 px-2 lighten-1 white--text font-weight-bold">
                                    {{ 'Week ' + year.ppm_week + ': ' + ((handy.formatDBDate(year.sched_dt) < today) && (year.ppm_status === 'Scheduled') ? 'Past Due' : year.ppm_status) + ' PPM Activities' }}
                                  </div>
                                </v-flex>
                                <v-flex xs12 v-for="(ppm, n) in year.ppmList" :key="n">
                                  <v-layout row wrap>
                                    <v-flex xs8 class="py-2 pl-2 pr-0">
                                      <div class="font-weight-bold">{{ppm.freq + ' - ' + (ppm.asset_id ? (ppm.asset_cat + ' ' + ppm.asset_name) : ppm.noneq_name)}}</div>
                                      <div>{{ppm.activity_desc}}</div>
                                    </v-flex>
                                    <v-flex xs4 class="pa-0 text-xs-right">
                                      <v-btn class="pa-0 ma-0" icon @click="prepareEdit(ppm, year.ppm_week)"><v-icon small>edit</v-icon></v-btn>
                                      <v-btn class="pa-0 ma-0" icon @click="loadServiceHistory(ppm, year.ppm_week)"><v-icon small>build</v-icon></v-btn>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider v-if="n !== year.ppmList.length - 1"></v-divider>
                                </v-flex>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- reports -->
            <v-tab-item :key="1" value="tab-1">
              <v-layout row wrap v-if="lRAction === 'view'">
                <v-flex xs12 sm6 class="pa-2">
                  <v-card @click="viewPpmSummary()">
                    <v-card-text class="text-xs-center">
                      PPM Summary
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 class="pa-2">
                  <v-card @click="viewServiceHistRep()">
                    <v-card-text class="text-xs-center">
                      Service History Reports
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-container v-if="lRAction === 'viewServiceHist'" class="pt-0">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card flat>
                      <v-card-title class="py-0 title">
                        <v-btn small flat style="margin-left: -60px;" @click="lRAction = 'view'"><v-icon>keyboard_backspace</v-icon></v-btn>
                        <v-flex xs12 sm6 style="margin-left: -40px;">
                          <span v-for="(chip, index) in reportChip" :key="index">
                            <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="loadDashboardBasedOnPeriod(chip)" :class="selectedChip === chip ? 'primary white--text' : ''">
                              {{chip}}
                            </v-chip>
                          </span>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="selectedChip === 'Specific Date'">
                          <v-layout row wrap>
                            <v-flex xs4 sm4>
                              <v-dialog ref="dlgFromDt"
                              persistent v-model="dlgFromDt"
                              lazy max-width="290px"
                              :return-value.sync="lReport.from_dt"
                              >
                                <v-text-field
                                slot="activator" label="From"
                                v-model="lReport.from_dt" append-icon="event"
                                readonly clearable
                                hide-details
                                ></v-text-field>
                                <v-date-picker v-model="lReport.from_dt"
                                first-day-of-week="1"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="dlgFromDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.dlgFromDt.save(lReport.from_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs4 sm4>
                              <v-dialog ref="dlgToDt"
                              persistent v-model="dlgToDt"
                              lazy max-width="290px"
                              :return-value.sync="lReport.to_dt"
                              >
                                <v-text-field
                                slot="activator" label="To"
                                v-model="lReport.to_dt" append-icon="event"
                                readonly clearable
                                hide-details
                                ></v-text-field>
                                <v-date-picker v-model="lReport.to_dt"
                                first-day-of-week="1"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="dlgToDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.dlgToDt.save(lReport.to_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs3 sm2>
                              <v-btn
                              fab small
                              class="accent"
                              @click.native="loadDashboardBasedOnPeriod('Specific Date')"
                              >
                              Go
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                  <!--show the list-->
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="py-0 title grey lighten-4">
                        <v-flex xs6>
                          {{ 'Service History Lists (' + serviceHist.length + ')' }}
                        </v-flex>
                        <v-flex xs6>
                          <v-download-as
                          :headers="serviceHistHead"
                          :items="serviceHist"
                          title="Service History List"
                          :landscape="true"
                          ></v-download-as>
                        </v-flex>
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <v-data-table
                        :headers="serviceHistHead"
                        :items="serviceHist"
                        :search="search"
                        hide-actions
                        disable-initial-sort
                        >
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td>{{ handy.formatDate(props.item.service_hist_dt) }}</td>
                              <td>{{ props.item.asset_cat }}</td>
                              <td>{{ props.item.asset_name }}</td>
                              <td>{{ props.item.asset_tag }}</td>
                              <td>{{ props.item.service_hist_desc }}</td>
                              <td>{{ props.item.service_hist_cost }}</td>
                              <td>{{ props.item.asset_location }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-if="lRAction === 'viewPpmSum'" class="pt-0">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card flat>
                      <v-card-title class="py-0 title">
                        <v-btn small flat style="margin-left: -60px;" @click="lRAction = 'view'"><v-icon>keyboard_backspace</v-icon></v-btn>
                        <v-flex xs12 sm6 style="margin-left: -40px;">
                          <span v-for="(chip, index) in reportChip" :key="index">
                            <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="loadPpmListBasedOnPeriod(chip)" :class="selectedChipForPpm === chip ? 'primary white--text' : ''">
                              {{chip}}
                            </v-chip>
                          </span>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="selectedChipForPpm === 'Specific Date'">
                          <v-layout row wrap>
                            <v-flex xs4 sm4>
                              <v-dialog ref="dlgStartDt"
                              persistent v-model="dlgStartDt"
                              lazy max-width="290px"
                              :return-value.sync="lPpmRep.from_dt"
                              >
                                <v-text-field
                                slot="activator" label="From"
                                v-model="lPpmRep.from_dt" append-icon="event"
                                readonly clearable
                                hide-details
                                ></v-text-field>
                                <v-date-picker v-model="lPpmRep.from_dt"
                                first-day-of-week="1"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="dlgStartDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.dlgStartDt.save(lPpmRep.from_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs4 sm4>
                              <v-dialog ref="dlgEndDt"
                              persistent v-model="dlgEndDt"
                              lazy max-width="290px"
                              :return-value.sync="lPpmRep.to_dt"
                              >
                                <v-text-field
                                slot="activator" label="To"
                                v-model="lPpmRep.to_dt" append-icon="event"
                                readonly clearable
                                hide-details
                                ></v-text-field>
                                <v-date-picker v-model="lPpmRep.to_dt"
                                first-day-of-week="1"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="dlgEndDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.dlgEndDt.save(lPpmRep.to_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs3 sm2>
                              <v-btn
                              fab small
                              class="accent"
                              @click.native="loadPpmListBasedOnPeriod('Specific Date')"
                              >
                              Go
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                  <!--show the list-->
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="py-0 title grey lighten-4">
                        <v-flex xs6>
                          {{ 'PPM Summary (' + ppmList.length + ')' }}
                        </v-flex>
                        <v-flex xs6>
                          <v-download-as
                          :headers="ppmListHead"
                          :items="ppmList"
                          title="PPM Summary"
                          :landscape="true"
                          ></v-download-as>
                        </v-flex>
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <v-data-table
                        :headers="ppmListHead"
                        :items="ppmList"
                        :search="search"
                        hide-actions
                        disable-initial-sort
                        >
                          <template slot="items" slot-scope="props">
                            <tr>
                              <td>{{ props.item.ppm_cat }}</td>
                              <td>{{ props.item.asset_cat ? props.item.asset_cat : '-' }}</td>
                              <td>{{ props.item.asset_name ? props.item.asset_name : props.item.noneq_name }}</td>
                              <td>{{ props.item.activity_desc }}</td>
                              <td>{{ props.item.asset_tag ? props.item.asset_tag : '-' }}</td>
                              <td>{{ props.item.freq }}</td>
                              <td>{{ props.item.activity_by }}</td>
                              <td>{{ props.item.sched_dt ? handy.formatDate(props.item.sched_dt) : '-'}}</td>
                              <td>{{ props.item.comp_dt ? handy.formatDate(props.item.comp_dt) : '-' }}</td>
                              <td><v-btn icon small class="primary--text" @click="loadHistoryBasedOnAssetId(props.item)"><v-icon>history</v-icon></v-btn></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <!-- Upload btn -->
            <v-btn v-if="lAction === 'view' && this.tab === 'tab-0'"
            :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:10px;':'bottom:15px; left:310px;')"
            dark fab fixed small color="accent" @click.native="prepareUploadPpmPlanner()">
            <v-icon small>upload</v-icon>
            </v-btn>
            <!-- filter btn -->
            <v-btn small v-if="lAction === 'view' && lRAction === 'viewServiceHist'"
              :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:60px;':'bottom:15px; left:360px;')"
              dark fab fixed color="accent" @click.native="this.tab === 'tab-0' ? prepareFilter() : prepareSerHistFilter()">
              <v-badge overlap color="info">
                <template v-slot:badge v-if="this.tab === 'tab-0' ? enabledFilter : enabledHistFilter">
                  <v-icon class="caption">done</v-icon>
                </template>
                <v-icon class="pa-2">filter_list</v-icon>
              </v-badge>
            </v-btn>
            <!-- plus btn -->
            <v-btn v-if="lAction === 'view' && this.tab === 'tab-0'"
              :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
              dark fab fixed
              color="accent"
              @click.native="prepareCreate()">
              <v-icon small>add</v-icon>
            </v-btn>
          </v-tabs-items>
        </v-flex>
      </v-layout>

      <!-- 1. create ppm -->
      <v-container v-if="lAction === 'create'" class="pa-0" grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-form ref="lForm" @submit.prevent="saveChanges(lAction, lPpm.ppm_week)">
              <v-card flat>
                <v-flex xs12 sm7 mx-auto>
                  <v-card-text class="px-2 pb-2 pt-0">
                    <v-layout row wrap>
                      <v-flex xs12 class="pl-0">
                        <v-radio-group class="pa-0 my-label-text-size" row v-model="lPpm.ppm_cat" :mandatory="false" hide-details @change="changeAssetType()">
                          <v-radio label="Equipment" value="EQ"></v-radio>
                          <v-radio label="Non-equipment" value="NE"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs12 v-if="lPpm.ppm_cat === 'EQ'">
                        <v-layout row wrap>
                          <v-flex xs10>
                            <v-select
                            v-model="lPpm.asset_pair"
                            label="Assets"
                            :items="showNonCritical ? assetList : assetList.filter(rec => rec.is_critical)"
                            item-value="asset_id"
                            item-text="asset_name_and_spec"
                            hide-details
                            multiple
                            small-chips
                            clearable
                            deletable-chips
                            dense
                            ></v-select>
                          </v-flex>
                          <v-flex xs2 class="text-xs-right">
                            <v-btn icon class="grey lighten-2 mt-2" :to="{path: '/inventory'}"><v-icon>add</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs12>
                            <v-checkbox
                            v-model="showNonCritical"
                            label="Show non-critical also"
                            hide-details
                            class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-if="lPpm.ppm_cat === 'NE'">
                        <v-text-field
                        v-model="lPpm.noneq_name"
                        label="Enter non-equipment name"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lPpm.activity_desc"
                        label="PPM Title"
                        placeholder="Enter the description of PPM activity"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout rwo wrap>
                          <v-flex xs12 sm3>
                            <v-select
                            v-model="lPpm.freq"
                            label="Frequency"
                            :items="freqItems"
                            item-text="freq"
                            item-value="short_form"
                            :rules="[rules.required]"
                            hide-details
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm2>
                            <v-select
                            v-model="lPpm.month"
                            label="Starts from"
                            :items="monthItem"
                            item-value="value"
                            item-text="name"
                            hide-details
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm7>
                            <v-layout align-center class="pa-0 pt-2 ml-1">
                              <v-radio-group label="Duration: " class="my-label-text-size" row v-model="lPpm.toYears" :mandatory="true" hide-details @change="$forceUpdate()">
                                <v-radio label="1 Year" value="1" checked='1'></v-radio>
                                <v-radio label="2 Years" value="2"></v-radio>
                                <v-radio label="3 Years" value="3"></v-radio>
                              </v-radio-group>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6>
                        <v-dialog ref="scheduledDt"
                        persistent v-model="scheduledDt"
                        lazy max-width="290px"
                        :return-value.sync="lPpm.sched_dt"
                        >
                          <v-text-field
                          slot="activator" label="Scheduled Date"
                          v-model="lPpm.sched_dt"
                          append-icon="event"
                          readonly clearable
                          hide-details
                          ></v-text-field>
                          <v-date-picker v-model="lPpm.sched_dt" scrollable
                          :show-week="showWeek"
                          first-day-of-week="1"
                          >
                          <v-spacer></v-spacer>
                            <v-btn flat @click="scheduledDt = false">Cancel</v-btn>
                            <v-btn flat color="accent" @click="$refs.scheduledDt.save(lPpm.sched_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                        v-model="lPpm.key_staff_pair"
                        label="Key staffs"
                        :items="keyStaffLists"
                        item-text="user_name"
                        item-value="user_id"
                        hide-details
                        :rules="[rules.required]"
                        @change="ShowNonEMailIdsMsg()"
                        ></v-combobox>
                      </v-flex>
                      <div class="pt-2 primary--text">
                        Scheduled date is mandatory. Please make sure <strong> Date, Month and Year </strong> for scheduled date. PPM entry will be scheduled based on scheduled date and frequency upto selected schedule duration.
                      </div>
                      <div class="pt-2" v-if="showMsg">
                        Selected Staff will not get any notification as email is empty.
                        Please update the staff details in BackBone to get the notifications.
                      </div>
                      <v-flex xs12 class="pl-0">
                        <v-radio-group class="pa-0 my-label-text-size" row v-model="lPpm.activity_by" :mandatory="false" hide-details @change="$forceUpdate()">
                          <v-radio label="In-house activity" value="I"></v-radio>
                          <v-radio label="Vendor activity" value="V"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn @click="showCheckListDlg = true"><v-icon class="mr-2">check</v-icon>SOP CHECKLIST</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="lAction = 'view'">Cancel</v-btn>
                    <v-btn type="submit" class="accent">Save</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- 2. edit ppm -->
      <v-container v-if="lAction === 'update'" class="pa-0" grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-form ref="lForm" @submit.prevent="saveChanges(lAction, lPpm.ppm_week)">
              <v-card flat>
                <v-flex xs12 sm7 mx-auto>
                  <v-card-text class="px-2 pb-2 pt-0">
                    <v-layout row wrap>
                      <v-flex xs7 class="pl-0">
                        <v-radio-group class="pa-0 my-label-text-size" row v-model="lPpm.ppm_cat" :disabled="lAction === 'update'" :mandatory="false" hide-details @change="changeAssetType()">
                          <v-radio label="Equipment" value="EQ"></v-radio>
                          <v-radio label="Non-equipment" value="NE"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs2 class="pt-4 font-weight-bold grey--text">
                        <div>PPM Id : {{lPpm.ppm_id}}</div>
                      </v-flex>
                      <v-flex xs2 class="pt-4 font-weight-bold grey--text">
                        <div>Seq Id : {{lPpm.seq_no}}</div>
                      </v-flex>
                      <v-flex xs12 v-if="lPpm.ppm_cat === 'EQ'">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-select
                            v-model="lPpm.asset_pair"
                            label="Asset"
                            :items="assetList"
                            item-value="asset_id"
                            item-text="asset_name_and_spec"
                            hide-details
                            return-object
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-if="lPpm.ppm_cat === 'NE'">
                        <v-text-field
                        v-model="lPpm.noneq_name"
                        label="Enter non-equipment name"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lPpm.asset_tag"
                        label="Asset Tag"
                        hide-details
                        disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lPpm.activity_desc"
                        label="PPM Title"
                        placeholder="Enter the description of PPM activity"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lPpm.freq"
                        label="Frequency"
                        :items="freqItems"
                        item-text="freq"
                        item-value="short_form"
                        hide-details
                        dense
                        :disabled="lAction === 'update'"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                        v-model="lPpm.key_staff_pair"
                        label="Key staffs"
                        :items="keyStaffLists"
                        item-text="user_name"
                        item-value="user_id"
                        hide-details
                        @change="ShowNonEMailIdsMsg()"
                        ></v-combobox>
                      </v-flex>
                      <div class="pt-2" v-if="showMsg">
                        Selected Staff will not get any notification as email is empty.
                        Please update the staff details in BackBone to get the notifications.
                      </div>
                      <v-flex xs12 class="pl-0">
                        <v-radio-group class="pa-0 my-label-text-size" row v-model="lPpm.activity_by" :mandatory="false" hide-details @change="$forceUpdate()">
                          <v-radio label="In-house activity" value="I"></v-radio>
                          <v-radio label="Vendor activity" value="V"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs12 v-if="lAction === 'update'">
                        <v-alert class="accent lighten-4 pa-2" outline color="grey lighten-2" value="true">
                          <v-layout row wrap>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn @click="showCheckListDlg = true">
                                <v-icon class="mr-2">check</v-icon>
                                SOP CHECKLIST ({{sopList.compChecklist}}/{{sopList.length}}) {{sopList.not_ok > 0 ? '[' + sopList.not_ok + ' NOT OK]' : sopList.ok > 0 ? '[ALL OK]' : ''}}
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-select
                              v-model="lPpm.ppm_status"
                              label="Status"
                              :items="['Unscheduled', 'Scheduled', 'Completed']"
                              hide-details
                              @input="$forceUpdate()"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-dialog ref="scheduledDt"
                              persistent v-model="scheduledDt"
                              lazy max-width="290px"
                              :return-value.sync="lPpm.sched_dt"
                              >
                                <v-text-field
                                slot="activator" label="Scheduled Date"
                                v-model="lPpm.sched_dt"
                                append-icon="event"
                                readonly clearable
                                hide-details
                                required
                                :disabled="lPpm.ppm_status === 'Unscheduled'"
                                ></v-text-field>
                                <v-date-picker v-model="lPpm.sched_dt" scrollable
                                :disabled="lPpm.ppm_status === 'Unscheduled'"
                                :show-week="showWeek"
                                first-day-of-week="1"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="scheduledDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.scheduledDt.save(lPpm.sched_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-dialog ref="completedDt"
                              persistent v-model="completedDt"
                              lazy max-width="290px"
                              :return-value.sync="lPpm.comp_dt"
                              >
                                <v-text-field
                                slot="activator" label="Completed Date"
                                v-model="lPpm.comp_dt"
                                append-icon="event"
                                readonly clearable
                                hide-details
                                required
                                :disabled="lPpm.ppm_status === 'Unscheduled' || lPpm.ppm_status === 'Scheduled'"
                                ></v-text-field>
                                <v-date-picker v-model="lPpm.comp_dt" scrollable
                                :disabled="lPpm.ppm_status === 'Unscheduled' || lPpm.ppm_status === 'Scheduled'"
                                first-day-of-week="1" :show-week="showWeek"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn flat @click="completedDt = false">Cancel</v-btn>
                                  <v-btn flat color="accent" @click="$refs.completedDt.save(lPpm.comp_dt)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs12 class="pt-0" v-if="lPpm.activity_by === 'I'">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-select
                                  v-model="lPpm.staff_id"
                                  label="Technician"
                                  :items="mcList"
                                  item-text="user_name"
                                  item-value="user_id"
                                  hide-details
                                  ></v-select>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 class="pt-0" v-else>
                              <v-layout row wrap>
                                <v-flex xs10>
                                  <v-select
                                  v-model="lPpm.vendor_id"
                                  label="Vendor"
                                  :items="vendors"
                                  item-value="vendor_id"
                                  item-text="vendor_name"
                                  hide-details
                                  ></v-select>
                                </v-flex>
                                <v-flex xs2>
                                  <v-btn icon class="grey lighten-2 mt-2" :to="{path: '/vendor'}"><v-icon>add</v-icon></v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 class="pt-0">
                              <v-text-field
                              v-model="lPpm.observ"
                              label="Enter Summary"
                              hide-details
                              :rules="[rules.required]"
                              maxlength="200"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 class="pl-0">
                              <input style="display:none" type="file" ref="fileInput"
                              accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lPpm)"/>
                              <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                              <span v-if="lPpm.files && lPpm.files.filter(rec => rec.is_selected).length > 0">
                                <span v-for="(file, index) in lPpm.files.filter(rec => rec.is_selected)" :key="index">
                                  <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>
                                    <a :href="config.STATIC_FILES_DIR + file.file_url" download style="text-decoration: none;">
                                      <v-btn small icon class="ml-0 pa-0 info lighten-1 grey--text text--lighten-4">
                                        <v-icon small>file_download</v-icon>
                                      </v-btn>
                                    </a>{{ file.file_name }}</v-chip>
                                </span>
                              </span>
                              <span v-else class="caption black--text">Attach report if any (upto 20MB)</span>
                            </v-flex>
                          </v-layout>
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="lAction = 'view'">Cancel</v-btn>
                    <v-btn v-if="lAction === 'update'" @click="deletePpm(lPpm)">delete</v-btn>
                    <v-btn type="submit" class="accent">Save</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- 3. show filter category in bottom sheet -->
      <v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                  v-model="filterList.asset_cat_list"
                  label="Category ppp"
                  :items="catList"
                  item-value="asset_cat_id"
                  item-text="asset_cat"
                  hide-details
                  multiple
                  small chips
                  clearable
                  dense
                  return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group class="pa-0" row v-model="filterList.activity_by" :mandatory="false" hide-details @change="$forceUpdate()">
                    <v-radio label="In-house activity" value="I"></v-radio>
                    <v-radio label="Vendor activity" value="V"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                  v-model="filterList.is_critical"
                  label="Critical asset"
                  hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                  v-model="filterList.is_ne"
                  label="Non-equipment category"
                  hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click.stop="showFilter = false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat @click="clearFilter">Clear all</v-btn>
            <v-btn class="ma-0" flat color="accent" @click="applyFilter">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>

      <!-- 4. SOP checklist -->
      <v-dialog v-model="showCheckListDlg" scrollable max-width="800px">
        <v-card>
          <v-card-text class="py-2">
            <v-layout row wrap>
              <v-flex xs12 v-if="lAction === 'update'">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    class="pa-0 mt-1"
                    append-icon="search"
                    :placeholder="$vuetify.breakpoint.smAndUp?'Search by CheckList item, Observation, etc.':'Search'"
                    single-line
                    outline
                    hide-details
                    v-model="search"
                    clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-download-as
                    :headers="sopUpdateHead"
                    :items="sopList"
                    title="SOP CheckList"
                    :landscape="true"
                    ></v-download-as>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-btn v-if="sopList.length > 0" flat small class="text-xs-left accent" @click="prepareSopChecklistTimeLine()">Timeline</v-btn>
              </v-flex>
              <v-flex xs6 class="text-xs-right pa-0">
                <v-btn flat small class="accent" @click="prepareSopChecklist()">Add new</v-btn>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                :headers="lAction === 'create' ? sopHead : sopUpdateHead"
                :items="sopList"
                hide-actions
                disable-initial-sort
                :search="search"
                class="tblSopChecklist elevation-1">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td v-if="lAction === 'update'"  class="handle pl-1 pr-0"><v-icon small>zoom_out_map</v-icon></td>
                      <td>{{ props.item.cl_item }}</td>
                      <td v-if="lAction === 'update'">
                        <v-select
                        v-model="props.item.cl_result"
                        :items="['', 'OK', 'NOT OK']"
                        label="Result"
                        hide-details
                        class="caption"
                        dense
                        ></v-select>
                      </td>
                      <td v-if="lAction === 'update'" style="cursor: pointer;" @click="LoadImages(props.item)">
                        <v-badge overlap color="info">
                          <template v-slot:badge>
                            <span class="caption white--text">{{ props.item.tot_files }}</span>
                          </template>
                          <v-icon small class="pa-2">attach_file</v-icon>
                        </v-badge>
                      </td>
                      <td v-if="lAction === 'update'">
                        <v-text-field
                        v-model="props.item.cl_observ"
                        label="Observation"
                        maxlength="150"
                        hide-details
                        ></v-text-field>
                      </td>
                      <td>
                        <v-menu
                        :close-on-content-click="false"
                        top right class="mt-0">
                          <span slot="activator">
                            <v-btn icon slot="activator">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </span>
                          <!-- list of menuitems -->
                          <v-list class="py-0">
                            <v-list-tile @click="prepareUploadFile(props.item)" v-if="lAction === 'update'">
                              <v-list-tile-avatar><v-icon>attach_file</v-icon></v-list-tile-avatar>
                              <v-list-tile-title>Attach photo</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="lAction === 'update'"></v-divider>
                            <v-list-tile @click="prepareUpdateChecklist(props.item)" v-if="lAction === 'update'">
                              <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
                              <v-list-tile-title>Edit</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="deleteChecklist(props.item)">
                              <v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
                              <v-list-tile-title>Delete</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="px-2 pb-2">
            <v-btn flat class="accent--text" @click="prepareUpload()">Upload Checklists</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat v-if="lAction === 'update'" @click="updateChecklist(sopList)">save &amp; close</v-btn>
            <v-btn flat v-else @click="showCheckListDlg=false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 5. create/update checklist -->
      <v-dialog v-model="showEditChecklist" max-width="500px">
        <v-card>
          <v-card-title class="py-3 title grey lighten-4">
            <div v-if="lAction === 'create'">
              Create Checklist
            </div>
            <div v-else-if="lAction === 'update' && lSubAction !== 'attach'">
              Edit Checklist
            </div>
            <div v-else>
              Upload Photo
            </div>
          </v-card-title>
          <v-card-text class="py-2">
            <v-flex xs12 v-if="lAction === 'create' || (lAction === 'update' && lSubAction !== 'attach')">
              <v-text-field
              v-model="lSop.cl_item"
              label="Checklist Item"
              :rules="[rules.required]"
              maxlength="150"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="lSubAction === 'attach'">
              <v-flex xs12>
                <input style="display:none" type="file" ref="fileInput"
                accept="image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lSop)"/>
                <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                <span v-if="lSop.files && lSop.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lSop.files.filter(rec => rec.is_selected)" :key="index">
                    <v-chip v-model="file.is_selected" @input="$forceUpdate()" close>{{ file.file_name }}</v-chip>
                  </span>
                </span>
                <span v-else class="caption black--text">Attach photos if any (upto 20MB)</span>
              </v-flex>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showEditChecklist = false; lSubAction=''">close</v-btn>
            <v-btn flat class="accent--text" @click="saveChecklist()">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showChecklistUpload" max-width="700px">
        <!-- 6. upload checklist-->
        <v-container v-if="lMAction === 'upload'" class="pa-0" grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card flat>
                <v-card-title class="title grey lighten-4">
                  Upload SOP CheckList
                </v-card-title>
                <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">In just 4 steps</div>
                <v-card-text class="subheading">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 1</v-chip>
                      <span>Download template</span>
                      <span style="float:right;">
                        <form method="get" action="../static/files/Smartility_SOP_List_Template.xlsx">
                          <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                        </form>
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 2</v-chip>
                      <span>Fill-in details as guided in template</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 3</v-chip>
                      <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
                        <span class="caption grey--text pl-4 ml-4">
                          <span class="ml-4">Go with OK/Yes when prompted while saving</span>
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 4</v-chip>
                      <span>Upload the CSV file</span>
                      <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
                      <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
                    </v-flex>
                    <v-flex xs12>
                      <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Uniservice takes care of rest</div>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 4</v-chip>
                      <span>Validate your information</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-chip small disabled outline class="primary--text">Step 5</v-chip>
                      <span>Create SOP Checklist</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer></v-spacer>
                  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- 7. validate SOP uploaded file -->
        <v-container v-if="lMAction === 'validate'" class="pa-0" grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card flat>
                <v-card-title class="title grey lighten-4">
                  Upload SOP CheckList
                </v-card-title>
                <v-card-text class="text-xs-center pl-2 pr-2">
                  <v-layout row wrap>
                    <v-flex xs12 md9 mx-auto>
                      <v-layout row wrap>
                        <v-flex xs12 class="info--text mb-2">
                          <span v-if="validateInProgress">Loading and validating the file...</span>
                          <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                          <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                          <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                          <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                          <span v-if="!totFail && !loadInProgress">SOP checklist upload was successfull<v-icon class="success--text">check</v-icon></span>
                          <span v-if="!totLoaded && totFail && !loadInProgress"><br />SOP checklist has failed<v-icon class="error--text">close</v-icon></span>
                          <span v-if="totLoaded && totFail && !loadInProgress"><br />SOP checklist partially failed<v-icon class="warning--text">close</v-icon></span>
                          <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                        </v-flex>
                        <v-flex xs4 v-if="totRecs">
                          <v-progress-circular color="info"
                          :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                          :size="50" :width="7">
                          {{ readyForLoad ? totValid : recsLoaded.length }}
                          </v-progress-circular>
                          <br/><div class="caption grey--text">Records</div>
                        </v-flex>
                        <v-flex xs4 v-if="totRecs">
                          <v-progress-circular color="success"
                          :value="(totValid/totRecs*100)"
                          :size="50" :width="7">
                          {{ readyForLoad ? totLoaded : totValid }}
                          </v-progress-circular>
                          <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
                        </v-flex>
                        <v-flex xs4 v-if="totRecs">
                          <v-progress-circular color="error"
                          :value="(totInvalid/totRecs*100)"
                          :size="50" :width="7">
                          {{ readyForLoad ? totFail : totInvalid }}
                          </v-progress-circular>
                          <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
                        </v-flex>
                        <v-flex xs12>
                          <v-btn small @click.native="lMAction='upload'">Cancel</v-btn>
                          <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadSopChecklist">Process the valid records</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 class="mt-2">
                      <v-data-table
                      :headers="loadHeadSm"
                      :items="recsLoaded"
                      hide-actions
                      class="elevation-3 text-xs-left"
                      disable-initial-sort
                      >
                        <template slot="items" slot-scope="props">
                          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
                            <td>{{ props.item.cl_item }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="pt-0" v-if="false">
                  <v-spacer></v-spacer>
                  <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-dialog>

      <!-- 8. show Sop checklist Images -->
      <v-dialog v-model="showSopImages" max-width="800px">
        <v-card flat>
          <v-card-title class="title grey lighten-4 pr-0 py-2">
            <span>{{sopFiles.cl_item}}</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="showSopImages = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-2" v-if="sopFiles.files && sopFiles.files.filter(rec => rec.is_selected).length > 0">
            <div v-viewer="options" class="clearfix">
              <template v-for="(file, index) in sopFiles.files">
                <img width="180px" :src="config.STATIC_FILES_DIR + file.file_url" :data-source="config.STATIC_FILES_DIR + file.file_url" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 9. show sop CheckList timeline -->
      <v-dialog v-model="showTimeline" max-width="600px">
        <v-card flat>
          <v-card-title class="pa-0 title grey lighten-4">
            <div class="px-2">Timeline</div>
            <v-spacer></v-spacer>
            <v-btn icon small @click.stop="showTimeline = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="timelineHead"
            :items="lChecklistDetails"
            hide-actions
            disable-initial-sort
            class="elevation-1">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.cl_item }}</td>
                  <td>{{ props.item.cust_name }}</td>
                  <td>{{ props.item.cl_result }}</td>
                  <td>{{ props.item.cl_observ }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 10. Asset service history -->
      <v-dialog v-model="showSerHist" persistent max-width="500px">
        <v-card v-if="lSHAction === 'view'" flat>
          <v-card-title class="pa-2 subheading font-weight-bold grey lighten-4">
            {{ assetDet.asset_cat + ':' + assetDet.asset_name + ' (Service history)' }}
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="showSerHist = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-flex xs12 sm9 md12 class="mx-auto">
              <v-spacer></v-spacer>
              <v-btn color="accent" flat class="mb-0" style="float: right" @click="prepareCreateServiceHist(assetDet)">Add New</v-btn>
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp ? assHistHead : assHistHeadsm"
              :items="histList"
              hide-actions
              disable-initial-sort
              class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr @click="prepareEditHist(props.item)">
                    <td>{{ handy.formatDate(props.item.service_hist_dt) }}</td>
                    <td>{{ props.item.service_hist_desc }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.service_hist_cost ? handy.formatCur(props.item.service_hist_cost) : '' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
        <!-- create / edit service histroy -->
        <v-container v-if="lSHAction === 'create' || lSHAction === 'update'" class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-form ref="shForm" @submit.prevent="saveServiceHistory(lSHAction)">
                <v-card flat>
                  <v-card-title class="pa-1 subheading font-weight-bold grey lighten-4">
                    {{ assetDet.asset_name }}
                    <v-spacer></v-spacer>
                    <v-btn small icon @click.stop="lSHAction = 'view'"><v-icon>close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-title class="subheading font-weight-bold pb-0">
                    {{ handy.startWithUpper(lSHAction) + ' Service History' }}
                  </v-card-title>
                  <v-card-text>
                    <v-flex xs12 md11 class="mx-auto">
                      <v-flex xs12>
                        <v-dialog ref="dlgservicehistDt"
                        persistent v-model="dlgservicehistDt"
                        lazy max-width="290px"
                        class="pt-0"
                        :return-value.sync="lHist.service_hist_dt">
                          <v-text-field
                          slot="activator" label="Service date"
                          v-model="lHist.service_hist_dt" append-icon="event"
                          readonly
                          hide-details
                          ></v-text-field>
                          <v-date-picker
                          v-model="lHist.service_hist_dt"
                          scrollable
                          first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn flat @click="dlgservicehistDt = false">Cancel</v-btn>
                            <v-btn flat color="accent" @click="$refs.dlgservicehistDt.save(lHist.service_hist_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lHist.service_hist_desc"
                        label="Service description"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="1000"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                        v-model="lHist.service_hist_cost"
                        label="Service cost"
                        :rules="[rules.required]"
                        hide-details
                        type="number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-combobox
                        v-model="lHist.vendor_name"
                        label="Choose vendor"
                        :items= "vendors.map(rec => rec.vendor_name)"
                        maxlength="50"
                        hide-details
                        clearable
                        @input="findVendor(lHist)"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-dialog ref="dlgnextservicehistDt"
                        persistent v-model="dlgnextservicehistDt"
                        lazy max-width="290px"
                        class="pt-0"
                        :return-value.sync="lHist.next_service_due_dt">
                          <v-text-field
                          slot="activator" label="Next service due date"
                          v-model="lHist.next_service_due_dt" append-icon="event"
                          readonly
                          hide-details
                          ></v-text-field>
                          <v-date-picker v-model="lHist.next_service_due_dt" scrollable
                          :min="today" first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn flat @click="dlgnextservicehistDt = false">Cancel</v-btn>
                            <v-btn flat color="accent" @click="$refs.dlgnextservicehistDt.save(lHist.next_service_due_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.stop="cancelChangesServHist">Cancel</v-btn>
                    <v-btn flat v-if="lSHAction === 'update'" :disabled="beingSaved" @click="deleteServiceHist(lHist)">Delete</v-btn>
                    <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-dialog>

      <!-- 11. Upload PPM Planner -->
      <v-container v-if="lAction === 'upload'" class="pa-0" grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card flat>
              <v-card-title class="title pa-0 pl-3">
                Upload PPM Planner List
              </v-card-title>
              <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">In just 4 steps</div>
              <v-card-text class="subheading">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 1</v-chip>
                    <span>Download template</span>
                    <span style="float:right;">
                      <form method="get" action="../static/files/Smartility_Ppm_Planner_Template.xlsx">
                        <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                      </form>
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 2</v-chip>
                    <span>Fill-in details as guided in template</span>
                    <div class="caption grey--text pl-4 ml-4" v-if="lAction === 'upload'">
                      <span class="ml-4">Tip-1: <a style="text-decoration: underline;" @click="LoadKeyStaffIdList">list of Key Staffs</a></span>
                      <span class="ml-4">Tip-2: <a style="text-decoration: underline;" @click="LoadAssetDetailsList">Asset Details</a></span>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 3</v-chip>
                    <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
                      <span class="caption grey--text pl-4 ml-4">
                        <span class="ml-4">Go with OK/Yes when prompted while saving</span>
                      </span>
                    </span>
                  </v-flex>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 4</v-chip>
                    <span>Upload the CSV file</span>
                    <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
                    <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validatePPMFile()"/>
                  </v-flex>
                  <v-flex xs12>
                    <div class="mt-3 text-xs-center primary--text" style="font-family: 'Satisfy', cursive; font-size:200%; font-weight:normal">Uniservice takes care of rest</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 4</v-chip>
                    <span>Validate your information</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-chip small disabled outline class="primary--text">Step 5</v-chip>
                    <span>Create PPM Planner List</span>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pt-0 pr-4">
                <v-spacer></v-spacer>
                <v-btn @click.native="lAction = 'view'">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- 12. showing key staff id for ppm bulk upload -->
      <v-dialog v-model="showKeyStaffIdList" persistent max-width="650px">
        <v-card>
          <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
            Key Staffs
            <v-spacer></v-spacer>
            <v-btn icon small @click="showKeyStaffIdList = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-layout>
            <v-flex xs12 class="text-xs-right pa-0">
              <v-download-as
              :headers="keyStaffHead"
              :items="keyStaffLists"
              title="Key Staffs List"
              :landscape="true"
              :fontsize="8"
              ></v-download-as>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-data-table
            :headers="keyStaffHead"
            :items="keyStaffLists"
            hide-actions
            dense
            disable-initial-sort
            class="elevation-1">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.user_id }}</td>
                  <td>{{ props.item.user_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 13. showing asset details list for ppm bulk upload -->
      <v-dialog v-model="showAssetDetailsList" persistent max-width="650px">
        <v-card>
          <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
            Asset List Details
            <v-spacer></v-spacer>
            <v-btn icon small @click="showAssetDetailsList = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-layout>
            <v-flex xs12 class="text-xs-right pa-0">
              <v-download-as
              :headers="assetListHead"
              :items="assetList"
              title="Asset List"
              :landscape="true"
              :fontsize="8"
              ></v-download-as>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-data-table
            :headers="assetListHead"
            :items="assetList"
            hide-actions
            disable-initial-sort
            class="elevation-1">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ props.item.assettype }}</td>
                  <td>{{ props.item.asset_id }}</td>
                  <td>{{ props.item.asset_name }}</td>
                  <td>{{ props.item.asset_tag }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- 14. validate PPM Upload file -->
      <v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md max-width="500px">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card flat>
              <v-card-title class="title pa-0 pl-3">
                Upload PPM List
              </v-card-title>
              <v-card-text class="text-xs-center pl-2 pr-2">
                <v-layout row wrap>
                  <v-flex xs12 md9 mx-auto>
                    <v-layout row wrap>
                      <v-flex xs12 class="info--text mb-2">
                        <span v-if="validateInProgress">Loading and validating the file...</span>
                        <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                        <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                        <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                        <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                        <span v-if="!totFail && !loadInProgress">Asset list upload was successfull<v-icon class="success--text">check</v-icon></span>
                        <span v-if="!totLoaded && totFail && !loadInProgress"><br />Asset list upload has failed<v-icon class="error--text">close</v-icon></span>
                        <span v-if="totLoaded && totFail && !loadInProgress"><br />Asset list upload partially failed<v-icon class="warning--text">close</v-icon></span>
                        <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                      </v-flex>
                      <v-flex xs4 v-if="totRecs">
                        <v-progress-circular color="info"
                        :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                        :size="50" :width="7">
                        {{ readyForLoad ? totValid : recsLoaded.length }}
                        </v-progress-circular>
                        <br/><div class="caption grey--text">Records</div>
                      </v-flex>
                      <v-flex xs4 v-if="totRecs">
                        <v-progress-circular color="success"
                        :value="(totValid/totRecs*100)"
                        :size="50" :width="7">
                        {{ readyForLoad ? totLoaded : totValid }}
                        </v-progress-circular>
                        <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
                      </v-flex>
                      <v-flex xs4 v-if="totRecs">
                        <v-progress-circular color="error"
                        :value="(totInvalid/totRecs*100)"
                        :size="50" :width="7">
                        {{ readyForLoad ? totFail : totInvalid }}
                        </v-progress-circular>
                        <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn small @click.native="lAction = 'upload'">Cancel</v-btn>
                        <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadPPMPlanner" :disabled="beingSaved">Process the valid records</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 class="mt-2">
                    <v-data-table
                    :headers="loadPPMHeadSm"
                    :items="recsLoaded"
                    hide-actions
                    class="elevation-3 text-xs-left"
                    disable-initial-sort
                    >
                      <template slot="items" slot-scope="props">
                        <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
                          <td>{{ props.item.ppm_cat }}</td>
                          <td>{{ props.item.noneq_nm }}</td>
                          <td>{{ props.item.asset_id }}</td>
                          <td>{{ props.item.ppm_title }}</td>
                          <td>{{ props.item.freq }}</td>
                          <td>{{ props.item.starting_month }}</td>
                          <td>{{ props.item.sched_dt }}</td>
                          <td>{{ props.item.noofyears }}</td>
                          <td>{{ props.item.key_staff_id }}</td>
                          <td>{{ props.item.activity_by }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pt-0" v-if="false">
                <v-spacer></v-spacer>
                <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- 15. show filter category in bottom sheet -->
      <v-bottom-sheet inset class="caption" v-model="showSerHistFilter" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md class="pa-0">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                  v-model="filterHistList.asset_name"
                  label="Asset Name"
                  hide-details
                  maxlength="100"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="filterHistList.asset_tag"
                  label="Asset Tag"
                  hide-details
                  maxlength="30"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="filterHistList.asset_cat_list"
                  label="Category"
                  :items="catList"
                  item-value="asset_cat_id"
                  item-text="asset_cat"
                  hide-details
                  multiple
                  small chips
                  clearable
                  deletable-chips
                  dense
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="filterHistList.vendor_list"
                  label="Vendor filter"
                  :items="vendors"
                  item-value="vendor_id"
                  item-text="vendor_name"
                  clearable
                  chips
                  multiple
                  hide-details
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn flat @click.stop="showSerHistFilter = false">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat @click="clearHistFilter">Clear all</v-btn>
            <v-btn class="ma-0" flat color="accent" @click="applyHistFilter">Apply</v-btn>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>

      <!-- 16. Asset service history -->
      <v-dialog v-model="showServiceHistDet" persistent max-width="600px">
        <v-card flat>
          <v-card-title class="py-0 subheading font-weight-bold grey lighten-4">
            Asset Details
            <v-spacer></v-spacer>
            <v-btn small icon @click.stop="showServiceHistDet = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md class="pt-0 px-0">
              <v-layout row wrap>
                <v-flex xs12 class="primary lighten-1">
                  <v-layout row wrap>
                    <v-flex xs5>
                      <div class="caption white--text">Asset Name: </div>
                      <div class="font-weight-bold white--text">{{serviceHistDet.asset_name}}</div>
                    </v-flex>
                    <v-flex xs3>
                      <div class="caption white--text">Asset Category: </div>
                      <div class="font-weight-bold white--text">{{serviceHistDet.asset_cat}}</div>
                    </v-flex>
                    <v-flex xs4>
                      <div class="caption white--text">Asset Tag: </div>
                      <div class="font-weight-bold white--text">{{serviceHistDet.asset_tag}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout pt-1>
                <v-flex xs11 pt-2>
                  <div class="subtitle black--text font-weight-bold">
                    Service History Details
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap pt-1>
                <v-card-text class="ma-0 pa-0">
                  <v-data-table
                  :headers="serviceHistListHead"
                  :items="serviceHistBasedOnAsset"
                  hide-actions
                  disable-initial-sort
                  dense
                  class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>{{ handy.formatDate(props.item.service_hist_dt) }}</td>
                        <td>{{ props.item.service_hist_desc }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.service_hist_cost ? handy.formatCur(props.item.service_hist_cost) : '' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- snack bar for reporting -->
      <v-snackbar :color="sbarCol" v-model="sbar"
      :timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
      </v-snackbar>
    </v-container>
  </div>
</template>

<style>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
import VDownloadAs from './VDownloadAs.vue'
import Sortable from 'sortablejs'
var html2pdf = require('html2pdf.js')

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  components: {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      handy: handy,
      config: config,
      lAction: '',
      lSubAction: '',
      rules: handy.rules,
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      // calendar
      chips: ['Month', 'Year'],
      enableChip: 'Month',
      start: handy.formatDBDate(Date()),
      calViewPeriod: new Date(),
      calViewTitle: '',
      startingWeekOfMonth: 0,
      endingWeekOfMonth: 0,
      catList: [],
      assetList: [],
      freqItems: [],
      monthItem: [],
      scheduledDt: false,
      completedDt: false,
      mcList: [],
      vendors: [],
      ppmCal: [],
      showNonCritical: false,
      keyStaffLists: [],
      monthList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      // filter
      enabledFilter: false,
      showFilter: false,
      filterList: [],
      // year variable
      endingWeek: null,
      calYearViewTitle: new Date().getFullYear(),
      yearPpmCal: [],
      selectedWeek: null,
      startingDateOfWeek: null,
      endingDateOfWeek: null,
      currentWeek: null,
      currentFreq: null,
      currentStatus: null,
      showWeek: true,
      statusChip: ['Unscheduled', 'Scheduled', 'Completed', 'Past Due'],
      filteredList: [],
      // SOP CheckList
      showCheckListDlg: false,
      lSop: {},
      sopHead: [
        { text: 'Checklist Item', value: 'cl_item' },
        { text: 'Action', value: '' }
      ],
      sopUpdateHead: [
        { text: '', value: '', class: 'pa-0' },
        { text: 'Checklist Item', value: 'cl_item' },
        { text: 'Result', value: 'cl_result' },
        { text: '', value: '' },
        { text: 'Observation', value: 'cl_observ' },
        { text: 'Action', value: '' }
      ],
      sopList: [],
      showEditChecklist: false,
      search: '',
      // checklist upload
      loadHeadSm: [
        { text: 'CheckList Item', value: 'cl_item' }
      ],
      reqHeaders: ['Checklist Item'],
      colNames: [
        { col_name: 'cl_item', is_required: true }
      ],
      showChecklistUpload: false,
      lMAction: '',
      sopFiles: [],
      showSopImages: false,
      options: {
        toolbar: true,
        url: 'data-source'
      },
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      showMsg: false,
      lChecklistDetails: [],
      showTimeline: false,
      timelineHead: [
        {text: 'Cl Item', value: 'cl_item'},
        {text: 'Updated By', value: 'cust_name'},
        {text: 'Cl Result', value: 'cl_result'},
        {text: 'Cl Observation', value: 'cl_observ'}
      ],
      showSerHist: false,
      histList: [],
      assetDet: '',
      assHistHead: [
        { text: 'Date', value: 'service_hist_dt' },
        { text: 'Description', value: 'service_hist_desc' },
        { text: 'Cost', value: 'service_hist_cost' }
      ],
      assHistHeadsm: [
        { text: 'Date', value: 'service_hist_dt' },
        { text: 'Description', value: 'service_hist_desc' }
      ],
      dlgservicehistDt: false,
      dlgnextservicehistDt: false,
      lHist: [],
      lSHAction: '',
      beingSaved: false,
      showKeyStaffIdList: false,
      showAssetDetailsList: false,
      assetListHead: [
        { text: 'Asset Type', value: 'assettype' },
        { text: 'Asset Id', value: 'asset_id' },
        { text: 'Asset Name', value: 'asset_name' },
        { text: 'Asset Tag', value: 'asset_tag' }
      ],
      keyStaffHead: [
        { text: 'Key Staff Id', value: 'user_id' },
        { text: 'Key Staff Name', value: 'user_name' }
      ],
      loadPPMHeadSm: [
        { text: 'Category', value: 'ppm_cat' },
        { text: 'Non-equipment Name', value: 'noneq_name' },
        { text: 'Asset Id', value: 'asset_id' },
        { text: 'PPM Title', value: 'ppm_title' },
        { text: 'Frequency', value: 'freq' },
        { text: 'Starting From', value: 'starting_month' },
        { text: 'Scheduled Date', value: 'sched_dt' },
        { text: 'No of Years', value: 'noofyears' },
        { text: 'Key Staff Id', value: 'key_staff_id' },
        { text: 'Is Vendor Activity?', value: 'activity_by' }
      ],
      // file upload
      reqPPMHeaders: ['Category', 'Non-equipment Name', 'Asset Id', 'PPM Title', 'Frequency', 'Starting From', 'Scheduled Date', 'No of Years', 'Key Staff Id', 'Is Vendor Activity?'],
      colPPMNames: [
        {col_name: 'ppm_cat', is_required: true},
        {col_name: 'noneq_nm', is_required: false},
        {col_name: 'asset_id', is_required: true},
        {col_name: 'ppm_title', is_required: true},
        {col_name: 'freq', is_required: true},
        {col_name: 'starting_month', is_required: true},
        {col_name: 'sched_dt', is_required: true},
        {col_name: 'noofyears', is_required: true},
        {col_name: 'key_staff_id', is_required: true},
        {col_name: 'activity_by', is_required: true}
      ],
      tab: 'tab-0',
      tabitems: ['52 Weeks PPM Planner', 'reports'],
      lReport: {},
      dlgFromDt: false,
      dlgToDt: false,
      serviceHist: [],
      serviceHistHead: [
        { text: 'Service Date', value: 'service_hist_dt' },
        { text: 'Category', value: 'asset_cat' },
        { text: 'Asset Name', value: 'asset_name' },
        { text: 'Asset Tag', value: 'asset_tag' },
        { text: 'Service Description', value: 'service_hist_desc' },
        { text: 'Service Cost', value: 'service_hist_cost' },
        { text: 'Asset Location', value: 'asset_location' }
      ],
      reportChip: ['Last Month', 'Last Week', 'Yesterday', 'Today', 'Specific Date'],
      selectedChip: '',
      showSerHistFilter: false,
      filterHistList: [],
      enabledHistFilter: false,
      showNonEq: false,
      lRAction: 'view',
      lPpmRep: {},
      dlgStartDt: false,
      dlgEndDt: false,
      ppmList: [],
      ppmListHead: [
        { text: 'PPM Category', value: 'ppm_cat' },
        { text: 'Asset Category', value: 'asset_cat' },
        { text: 'Asset Name', value: 'asset_name' },
        { text: 'PPM Title', value: 'activity_desc' },
        { text: 'Asset Tag', value: 'asset_tag' },
        { text: 'Frequency', value: 'freq' },
        { text: 'Activity By', value: 'activity_by' },
        { text: 'Scheduled Date', value: 'sched_dt' },
        { text: 'Completed Date', value: 'comp_dt' },
        { text: 'Service History', value: '', sortable: false }
      ],
      serviceHistBasedOnAsset: [],
      serviceHistListHead: [
        { text: 'Service Hstory Date', value: 'service_hist_dt' },
        { text: 'Service Description', value: 'service_hist_desc' },
        { text: 'Service Cost', value: 'service_hist_cost' }
      ],
      showServiceHistDet: false,
      serviceHistDet: [],
      selectedChipForPpm: [],
      // edit ppm Declarations
      ppmDetail: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    },
    eventsMap () {
      const map = {}
      var unscheduledData = this.ppmCal.filter(rec => rec.ppm_status === 'Unscheduled')
      var scheduledData = this.ppmCal.filter(rec => rec.ppm_status === 'Scheduled')
      var completedData = this.ppmCal.filter(rec => rec.ppm_status === 'Completed')
      if (scheduledData.length > 0) {
        scheduledData.forEach(e => {
          if (e.ppmList && e.ppmList.length > 0) {
            e.ppmList.forEach(schedDt => {
              (map[handy.formatDBDate(schedDt.sched_dt)] = map[handy.formatDBDate(schedDt.sched_dt)] || []).push(e)
            })
          }
        })
      }
      if (completedData.length > 0) {
        completedData.forEach(e => {
          if (e.ppmList && e.ppmList.length > 0) {
            e.ppmList.forEach(compDt => {
              (map[handy.formatDBDate(compDt.comp_dt)] = map[handy.formatDBDate(compDt.comp_dt)] || []).push(e)
            })
          }
        })
      }
      if (unscheduledData.length > 0) {
        unscheduledData.forEach(e => (map[handy.formatDBDate(e.ppm_week_start_dt)] = map[handy.formatDBDate(e.ppm_week_start_dt)] || []).push(e))
      }
      return map
    }
  },
  created () {
    // find current week for Year chip
    this.currentWeek = handy.getWeekOfTheYear(this.today)
    this.getNumberOfWeeks()
    // default title of calendar view
    this.calViewTitle = handy.getMonthName(this.calViewPeriod.getMonth()) + ' ' + this.calViewPeriod.getFullYear()
  },
  mounted () {
    this.dragElement()
    this.loadAssetList()
    this.loadPpmList()
    this.filterList = this.getEmptyFilter()
    this.lAction = 'view'
    var curDate = new Date()
    this.lReport.from_dt = this.lReport.to_dt = handy.formatDBDate(curDate)
    this.lPpmRep.from_dt = this.lPpmRep.to_dt = handy.formatDBDate(curDate)
    this.loadDashboardBasedOnPeriod('Yesterday')
    this.loadPpmListBasedOnPeriod('Yesterday')
    this.filterHistList = this.getEmptyFilterHist()
    this.loadAssetCategory()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    refreshTab () {
      if (this.tab === 'tab-1') {
        this.lRAction = 'view'
      }
    },
    prevMonth () {
      this.calViewPeriod.setMonth(this.calViewPeriod.getMonth() - 1)
      var curMonth = this.calViewPeriod.getMonth()
      this.calViewTitle = handy.getMonthName(curMonth) + ' ' + this.calViewPeriod.getFullYear()
      this.getNumberOfWeeks()
      this.$refs.calendar.prev()
      this.$forceUpdate()
    },
    nextMonth () {
      this.calViewPeriod.setMonth(this.calViewPeriod.getMonth() + 1)
      var curMonth = this.calViewPeriod.getMonth()
      this.calViewTitle = handy.getMonthName(curMonth) + ' ' + this.calViewPeriod.getFullYear()
      this.getNumberOfWeeks()
      this.$refs.calendar.next()
      this.$forceUpdate()
    },
    getNumberOfWeeks () {
      this.startingWeekOfMonth = 0
      this.endingWeekOfMonth = 0
      // starting date of the selected date
      var StartingDate = new Date(this.calViewPeriod.getFullYear(), this.calViewPeriod.getMonth(), 1)
      this.startingWeekOfMonth = handy.getWeekOfTheYear(StartingDate)
      // ending date of the selected month
      var endingDate = new Date(this.calViewPeriod.getFullYear(), this.calViewPeriod.getMonth() + 1, 0)
      this.endingWeekOfMonth = handy.getWeekOfTheYear(endingDate)
    },
    prepareCreate () {
      this.lPpm = {
        comm_id: config.COMM_ID,
        ppm_cat: 'EQ',
        ppm_week: [],
        asset_pair: [],
        noneq_name: '',
        freq: '',
        month: new Date().getMonth(),
        activity_desc: '',
        activity_by: 'I',
        ppm_status: 'Unscheduled',
        sched_dt: null,
        comp_dt: null,
        staff_id: null,
        vendor_id: null,
        observ: '',
        updated_by: config.USER_ID,
        key_staff_pair: '',
        files: [],
        toYears: '1'
      }
      this.sopList = []
      this.showNonCritical = false
      this.showMsg = false
      this.getMonthList()
      this.getFrequency()
      this.loadTechnicianList()
      this.loadVendorList()
      this.loadKeyStaffList()
      this.lAction = 'create'
    },
    changeAssetType () {
      if (this.lPpm.ppm_cat === 'NE') {
        this.lPpm.asset_pair = []
      } else {
        this.lPpm.noneq_name = ''
      }
      this.$forceUpdate()
    },
    getMonthList () {
      var count = 0
      this.monthItem = []
      this.monthList.forEach(rec => {
        this.monthItem.push({
          name: rec,
          value: count
        })
        count++
      })
    },
    getFrequency () {
      this.freqItems.push({freq: 'Only Once', short_form: 'S'})
      this.freqItems.push({freq: 'Weekly', short_form: 'W'})
      this.freqItems.push({freq: 'Biweekly', short_form: 'BW'})
      this.freqItems.push({freq: 'Monthly', short_form: 'M'})
      this.freqItems.push({freq: 'Bimonthly', short_form: 'BM'})
      this.freqItems.push({freq: 'Quarterly', short_form: 'Q'})
      this.freqItems.push({freq: 'Half yearly', short_form: 'HY'})
      this.freqItems.push({freq: 'Yearly', short_form: 'Y'})
    },
    loadAssetList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getAssetListByCommId/', qry)
      .then(response => {
        this.assetList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadAssetCategory () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getAssetCategoryByCommId/', qry)
      .then(response => {
        this.catList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadTechnicianList () {
      var qry = {
        params: {
          comm_id_list: config.COMM_ID,
          vendor_id: config.IS_BB_VENDOR ? config.FM_VENDOR_ID : ''
        }
      }
      this.mcList = []
      this.axios.get(config.API_URL + '/getEligibleAssigneeForComplaints/', qry)
      .then(response => {
        response.data.forEach(rec => {
          this.mcList.push({user_id: rec.user_id, user_name: handy.startWithUpper(rec.cust_name), is_sv_user: rec.is_sv_user})
        })
      })
    },
    loadKeyStaffList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.keyStaffLists = []
      this.axios.get(config.API_URL + '/getKeyStaffsFromCommunity/', qry)
      .then(response => {
        response.data.forEach(rec => {
          this.keyStaffLists.push({user_id: rec.vendor_emp_id, user_name: rec.emp_name, email: rec.emp_email})
        })
        this.ShowNonEMailIdsMsg()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    ShowNonEMailIdsMsg () {
      if (this.lPpm && this.lPpm.key_staff_pair) {
        var idx = this.keyStaffLists.findIndex(rec => rec.user_id === this.lPpm.key_staff_pair.user_id)
        if (idx > -1 && !this.keyStaffLists[idx].email) {
          this.showMsg = true
          this.$forceUpdate()
        } else {
          this.showMsg = false
          this.$forceUpdate()
        }
      }
    },
    loadVendorList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.vendors = []
      this.axios.get(config.API_URL + '/getVendorByCommId/', qry)
      .then(response => {
        this.vendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curTask) {
      const files = event.target.files
      if (!curTask.files) {
        curTask.files = []
        curTask.comm_id = config.COMM_ID
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curTask.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    saveChanges (action, curWeek) {
      if (this.$refs.lForm.validate()) {
        if (this.lPpm.ppm_cat === 'EQ' && this.lPpm.asset_pair.length === 0) {
          this.msg('Please select Asset', 0)
        } else if (!this.lPpm.key_staff_pair || !this.lPpm.key_staff_pair.user_id) {
          this.msg('Please enter Key staffs', 0)
        } else if (action === 'create' && this.lPpm.ppm_status !== 'Unscheduled' && !this.lPpm.sched_dt) {
          this.msg('Please enter Scheduled Date', 0)
        } else if (action === 'create' && new Date(this.lPpm.sched_dt).getMonth() !== this.lPpm.month) {
          this.msg('Starting from and Scheduled Month is not matching', 0)
        } else if (action === 'update' && this.lPpm.ppm_status === 'Completed' && this.lPpm.activity_by === 'I' && !this.lPpm.staff_id) {
          this.msg('Please enter Technician name', 0)
        } else if (action === 'update' && this.lPpm.ppm_status !== 'Unscheduled' && this.lPpm.activity_by === 'V' && !this.lPpm.vendor_id) {
          this.msg('Please enter Vendor name', 0)
        } else {
          if (action === 'update' && this.lPpm.ppm_status === 'Completed' && (!this.lPpm.sched_dt || !this.lPpm.comp_dt)) {
            this.msg('Please enter Scheduled Date and Completed Date', 0)
          } else if (action === 'update' && this.lPpm.ppm_status === 'Scheduled' && !this.lPpm.sched_dt) {
            this.msg('Please enter Scheduled Date', 0)
          } else {
            if (action === 'create') {
              // Keep calendarYear as base for start calendar year
              // var calendarYear = this.calViewPeriod.getFullYear()
              var calendarYear = new Date(this.lPpm.sched_dt).getFullYear()
              // RunningYear will be used to process. It will change based on selected years like 1 Year, 2 Years and 3 Years
              var calendarRunningYear = calendarYear
              var startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarYear, this.lPpm.month, 1)))
              // var endingWeek = handy.getWeekOfTheYear(new Date(calendarYear, 12, 0))
              var scheduleDay = new Date(this.lPpm.sched_dt).getDate()
              var scheduleMonth = new Date(this.lPpm.sched_dt).getMonth()
              var scheduleDate = this.lPpm.sched_dt
              var totMonths = this.lPpm.toYears * 12
              var processYearNo = 1
              var runningMonth = this.lPpm.month
              var totWeeks = this.lPpm.toYears * 53
              var schDateForWBW = this.lPpm.sched_dt
              this.lPpm.ppm_week = []
              if (this.lPpm.freq === 'S') {
                schDateForWBW = new Date(this.lPpm.sched_dt)
                var WBWYear = new Date(schDateForWBW).getFullYear()
                var WBWMonth = new Date(schDateForWBW).getMonth()
                var WBWDay = new Date(schDateForWBW).getDate()
                var weekNo = parseInt(handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay)))
                var yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
                if (weekNo === 53 && yearNo < calendarRunningYear) {
                  weekNo = 1
                  yearNo = yearNo + 1
                }
                this.lPpm.ppm_week.push({
                  week: weekNo,
                  week_year: yearNo,
                  start_date: handy.getDateOfWeek(weekNo, yearNo),
                  ppm_sch_status: 'Scheduled',
                  ppm_sch_date: handy.formatDBDate(schDateForWBW)
                })
              } else if (this.lPpm.freq === 'W') {
                for (var i = 0; i < totWeeks; i++) {
                  if (i === 0) {
                    schDateForWBW = new Date(this.lPpm.sched_dt)
                  } else {
                    var schDateForProess = new Date(schDateForWBW)
                    schDateForWBW = (schDateForProess.setDate(schDateForProess.getDate() + 7))
                  }
                  WBWYear = new Date(schDateForWBW).getFullYear()
                  WBWMonth = new Date(schDateForWBW).getMonth()
                  WBWDay = new Date(schDateForWBW).getDate()
                  weekNo = handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay))
                  yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
                  if (weekNo === 53 && yearNo < calendarRunningYear) {
                    weekNo = 1
                    yearNo = yearNo + 1
                  }
                  this.lPpm.ppm_week.push({
                    week: weekNo,
                    week_year: yearNo,
                    start_date: handy.getDateOfWeek(weekNo, yearNo),
                    ppm_sch_status: 'Scheduled',
                    ppm_sch_date: handy.formatDBDate(schDateForWBW)
                  })
                }
              } else if (this.lPpm.freq === 'BW') {
                for (i = 0; i < totWeeks; i += 2) {
                  if (i === 0) {
                    schDateForWBW = new Date(this.lPpm.sched_dt)
                  } else {
                    schDateForProess = new Date(schDateForWBW)
                    schDateForWBW = (schDateForProess.setDate(schDateForProess.getDate() + 14))
                  }
                  WBWYear = new Date(schDateForWBW).getFullYear()
                  WBWMonth = new Date(schDateForWBW).getMonth()
                  WBWDay = new Date(schDateForWBW).getDate()
                  weekNo = parseInt(handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay)))
                  yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
                  if (weekNo === 53 && yearNo < calendarRunningYear) {
                    weekNo = 1
                    yearNo = yearNo + 1
                  }
                  this.lPpm.ppm_week.push({
                    week: weekNo,
                    start_date: handy.getDateOfWeek(weekNo, yearNo),
                    ppm_sch_status: 'Scheduled',
                    ppm_sch_date: handy.formatDBDate(schDateForWBW)
                  })
                }
              } else if (this.lPpm.freq === 'M') {
                for (i = 0; i < totMonths; i++) {
                  calendarRunningYear = calendarYear + (processYearNo - 1)
                  startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                  this.pushSubsequentPPMSchedule(this.lPpm.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                  if (runningMonth === 11) {
                    processYearNo += 1
                    runningMonth = 0
                  } else {
                    runningMonth += 1
                  }
                }
              } else if (this.lPpm.freq === 'BM') {
                for (i = 0; i < totMonths; i += 2) {
                  calendarRunningYear = calendarYear + (processYearNo - 1)
                  startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                  this.pushSubsequentPPMSchedule(this.lPpm.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                  // If the runningMonth is 10 (means nov), it add the ppm entry for Nov (and next ppm entry for Jan of next year)
                  // Hence increase the year and set month 0 for Jan entry.
                  // If the runningMonth is 11 (means dec), it add the ppm entry for dec (and next ppm entry for Feb of next year)
                  // Hence increase the year and set month 1 for Feb entry.
                  if (runningMonth >= 10) {
                    // For Nov, Dec
                    processYearNo += 1
                    runningMonth = runningMonth - 10
                  } else {
                    runningMonth += 2
                  }
                }
              } else if (this.lPpm.freq === 'Q') {
                for (i = 0; i < totMonths; i += 3) {
                  calendarRunningYear = calendarYear + (processYearNo - 1)
                  startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                  this.pushSubsequentPPMSchedule(this.lPpm.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                  // If the runningMonth is 9 (means Oct), it add the ppm entry for Oct (and next ppm entry for Jan of next year)
                  // Hence increase the year and set month 0 for Jan entry.
                  // If the runningMonth is 10 (means Nov), it add the ppm entry for Nov (and next ppm entry for Feb of next year)
                  // Hence increase the year and set month 1 for Feb entry.
                  // If the runningMonth is 11 (means dec), it add the ppm entry for dec (and next ppm entry for Mar of next year)
                  // Hence increase the year and set month 2 for Mar entry.
                  if (runningMonth >= 9) {
                    // For Oct, Nov, Dec
                    processYearNo += 1
                    runningMonth = runningMonth - 9
                  } else {
                    runningMonth += 3
                  }
                }
              } else if (this.lPpm.freq === 'HY') {
                for (i = 0; i < totMonths; i += 6) {
                  calendarRunningYear = calendarYear + (processYearNo - 1)
                  startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                  this.pushSubsequentPPMSchedule(this.lPpm.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                  // If the runningMonth is 6 (means Jul), it add the ppm entry for Jul (and next ppm entry for Jan of next year)
                  // Hence increase the year and set month 0 for Jan entry.
                  // The same has been done for Aug, Sep, Oct, Nov, Dec
                  if (runningMonth >= 6) {
                    // For Jul, Aug, Sep, Oct, Nov, Dec
                    processYearNo += 1
                    runningMonth = runningMonth - 6
                  } else {
                    runningMonth += 6
                  }
                }
              } else if (this.lPpm.freq === 'Y') {
                for (i = 0; i < totMonths; i += 12) {
                  calendarRunningYear = calendarYear + (processYearNo - 1)
                  startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                  this.pushSubsequentPPMSchedule(this.lPpm.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                  // Keep the runningmonth value unchanged and incrase processYearNo for each time
                  processYearNo += 1
                }
              }
            }
            if (action === 'update') {
              if (this.lPpm.ppm_status === 'Completed') {
                // this.lPpm.ppm_week = parseInt(handy.getWeekNumber70(new Date(this.lPpm.comp_dt)))
                weekNo = parseInt(handy.getWeekNumber70(new Date(this.lPpm.comp_dt)))
              } else if (this.lPpm.ppm_status === 'Scheduled') {
                // this.lPpm.ppm_week = parseInt(handy.getWeekNumber70(new Date(this.lPpm.sched_dt)))
                weekNo = parseInt(handy.getWeekNumber70(new Date(this.lPpm.sched_dt)))
              } else {
                weekNo = curWeek
              }
              if (weekNo === 53) {
                this.lPpm.ppm_week = 1
              } else {
                this.lPpm.ppm_week = weekNo
              }
            }
            if (this.sopList.length > 0) {
              this.lPpm.sopChecklist = this.sopList
            } else {
              this.lPpm.sopChecklist = []
            }
            this.lPpm.comm_id = config.COMM_ID
            this.axios.post(config.API_URL + '/ppm/' + action, this.lPpm)
            .then(response => {
              if (this.enableChip === 'Month') {
                setTimeout(() => {
                  this.loadPpmList()
                  this.eventsMap
                }, 1000)
              } else {
                setTimeout(() => {
                  this.loadPpmList()
                }, 1000)
              }
              this.lAction = 'view'
            })
            .catch(err => {
              this.msg(err, 0)
            })
          }
        }
      }
    },
    pushSubsequentPPMSchedule (curPPMWeek, i, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate) {
      // In case starting from month is lesser than month of entered shedule date - no action, make the PPM entry Unscheduled.
      // This case will not be executed since restriction added to match stating from month and scheduled date month should be same.
      if (i < scheduleMonth && calendarRunningYear === calendarYear) {
        curPPMWeek.push({
          week: startingWeek,
          start_date: handy.getDateOfWeek(startingWeek, calendarRunningYear),
          sch_ppm_status: 'Unscheduled'
        })
      } else if (i === scheduleMonth && calendarRunningYear === calendarYear) {
        // starting from month is equal to month of entered shedule date - make entered scheduled date as scheduled date
        var weekNo = parseInt(handy.getWeekNumber70(new Date(scheduleDate)))
        var yearNo = handy.getWeekNumberOfYear70(new Date(scheduleDate))
        if (weekNo >= 52 && yearNo < calendarRunningYear && scheduleDay <= 6) {
          weekNo = 1
          yearNo = yearNo + 1
        }
        curPPMWeek.push({
          week: weekNo,
          start_date: handy.getDateOfWeek(weekNo, yearNo),
          ppm_sch_status: 'Scheduled',
          ppm_sch_date: handy.formatDBDate(new Date(scheduleDate))
        })
      } else {
        // In case starting from month (i > sch_month) is greater than month of entered shedule date - make month, daybas per month max days.
        // 31 days months - If months are 'Jan is 0', 'March is 2', 'May is 4', 'July is 6', 'Aug is 7', 'Oct is 9', 'Dec is 11'
        if (i === 0 || i === 2 || i === 4 || i === 6 || i === 7 || i === 9 || i === 11) {
          scheduleDate = new Date(calendarRunningYear, i, scheduleDay)
        }
        // 30 days months - If months are 'April is 3', 'June is 5', 'Sept is 8', 'Nov is 10'
        if (i === 3 || i === 5 || i === 8 || i === 10) {
          if (scheduleDay <= 30) {
            scheduleDate = new Date(calendarRunningYear, i, scheduleDay)
          } else {
            scheduleDate = new Date(calendarRunningYear, i, 30)
          }
        }
        // 28/29 days month - feb - If month is 'Feb is 1'
        if (i === 1) {
          if (scheduleDay <= 28) {
            scheduleDate = new Date(calendarRunningYear, i, scheduleDay)
          } else {
            scheduleDate = new Date(calendarRunningYear, i, 28)
          }
        }
        weekNo = parseInt(handy.getWeekNumber70(new Date(scheduleDate)))
        yearNo = handy.getWeekNumberOfYear70(new Date(scheduleDate))
        if (weekNo >= 52 && yearNo < calendarRunningYear && scheduleDay <= 6) {
          weekNo = 1
          yearNo = yearNo + 1
        }
        curPPMWeek.push({
          week: weekNo,
          start_date: handy.getDateOfWeek(weekNo, yearNo),
          ppm_sch_status: 'Scheduled',
          ppm_sch_date: handy.formatDBDate(scheduleDate)
        })
      }
    },
    loadPpmList () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          view: this.enableChip,
          filter: this.filterList
        }
      }
      this.ppmCal = []
      this.axios.get(config.API_URL + '/getListOfPpmCalByCommId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.ppmCal = this.showNonEq ? response.data.filter(rec => rec.ppm_cat === 'NE') : response.data
        } else {
          this.ppmCal = []
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEdit (curPpm, ppm) {
      this.loadPPMDetail(curPpm.ppm_id)
      setTimeout(() => {
        this.loadPpmAttachment(curPpm)
        this.lPpm = Object.assign({}, curPpm) // keep the original object safely before changes
        this.lPpm.key_staff_pair = { user_id: curPpm.key_staff_id, user_name: curPpm.emp_name }
        this.lPpm.asset_pair = {asset_id: parseInt(curPpm.asset_id), asset_name: curPpm.asset_cat + ' - ' + curPpm.asset_name}
        var criticalAsset = this.assetList.filter(rec => rec.is_critical)
        this.showNonCritical = !criticalAsset.map(rec => rec.asset_id === parseInt(curPpm.asset_id))[0]
        this.lPpm.ppm_week = ppm.ppm_week
        this.lPpm.asset_tag = curPpm.asset_tag
        this.lPpm.old_sched_dt = this.ppmDetail.sched_dt ? handy.formatDBDate(this.ppmDetail.sched_dt) : null
        this.lPpm.old_comp_dt = this.ppmDetail.comp_dt ? handy.formatDBDate(this.ppmDetail.comp_dt) : null
        this.lPpm.old_ppm_status = this.ppmDetail.ppm_status ? this.ppmDetail.ppm_status : null
        this.lPpm.sched_dt = this.ppmDetail.sched_dt ? handy.formatDBDate(this.ppmDetail.sched_dt) : null
        this.lPpm.comp_dt = this.ppmDetail.comp_dt ? handy.formatDBDate(this.ppmDetail.comp_dt) : null
        this.lPpm.seq_no = this.ppmDetail.seq_no ? this.ppmDetail.seq_no : 0
        // var idx = this.ppmCal.findIndex(rec => rec.ppm_id.includes(curPpm.ppm_id))
        // if (idx > -1) {
        //   this.lPpm.sched_dt = this.ppmCal[idx].sched_dt
        //   this.lPpm.comp_dt = this.ppmCal[idx].comp_dt
        // }
        this.getMonthList()
        this.getFrequency()
        this.loadTechnicianList()
        this.loadKeyStaffList()
        this.loadVendorList()
        this.loadChecklist(curPpm.ppm_id)
        this.lAction = 'update'
        this.showNonCritical = false
      }, 500)
    },
    loadPPMDetail (curPpmId) {
      var qry = {
        params: {
          ppm_id: curPpmId
        }
      }
      this.ppmDetail = []
      this.axios.get(config.API_URL + '/getPPMDetailByPpmId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.ppmDetail = response.data[0]
        } else {
          this.ppmDetail = []
        }
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadPpmAttachment (curPpm) {
      var path = require('path')
      var qry = {
        params: {
          ppm_id: curPpm.ppm_id
        }
      }
      curPpm.files = []
      this.axios.get(config.API_URL + '/getAttachmentByPpmId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          const idx = curPpm.files.findIndex(file => file.file_url)
          if (idx < 0) {
            curPpm.files.push({
              file_url: rec.file_url,
              file_name: path.basename(rec.file_url),
              is_selected: true,
              is_changed: false
            })
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deletePpm (curPpm) {
      if (!confirm('Sure, you want to delete the PPM with description ' + curPpm.activity_desc)) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/ppm/delete', curPpm)
      .then(response => {
        this.loadPpmList()
        this.eventsMap
        this.lAction = 'view'
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareFilter () {
      this.loadAssetCategory()
      this.showFilter = true
    },
    getEmptyFilter () {
      var filter = {
        activity_by: '',
        asset_cat_list: [],
        is_critical: false,
        is_ne: false
      }
      return filter
    },
    clearFilter () {
      this.filterList.activity_by = ''
      this.filterList.is_ne = false
      this.filterList.asset_cat_list = []
      this.filterList.is_critical = false
      this.loadPpmList()
      this.eventsMap
      this.enabledFilter = false
      this.showFilter = false
      this.$forceUpdate()
    },
    applyFilter () {
      this.filteredList = ''
      if (this.filterList.activity_by || this.filterList.is_ne || this.filterList.asset_cat_list && this.filterList.asset_cat_list.length || this.filterList.is_critical) {
        this.enabledFilter = true
      }
      if (this.filterList.asset_cat_list && this.filterList.asset_cat_list.length > 0) {
        this.filteredList = this.filterList.asset_cat_list.map(rec => rec.asset_cat).join()
      }
      setTimeout(() => {
        this.loadPpmList()
        this.eventsMap
      }, 1000)
      this.showFilter = false
    },
    returnEnableChip (curChip) {
      if (curChip === 'Year') {
        this.endingWeek = parseInt(handy.getWeekOfTheYear(new Date(this.calViewPeriod.getFullYear(), 11 + 1, 0)))
      } else {
        this.eventsMap
      }
      this.enableChip = curChip
      this.loadPpmList()
    },
    prevYear () {
      this.calYearViewTitle = this.calYearViewTitle - 1
      this.endingWeek = parseInt(handy.getWeekOfTheYear(new Date(this.calYearViewTitle, 11 + 1, 0)))
    },
    nextYear () {
      this.calYearViewTitle = this.calYearViewTitle + 1
      this.endingWeek = parseInt(handy.getWeekOfTheYear(new Date(this.calYearViewTitle, 11 + 1, 0)))
    },
    prepareSopChecklist () {
      this.lSop = {
        cl_item: ''
      }
      this.showEditChecklist = true
    },
    saveChecklist () {
      if (this.lSop.cl_id) {
        var idx = this.sopList.findIndex(rec => rec.cl_id === this.lSop.cl_id)
        if (this.lSop.files.length > 0) {
          this.lSop.tot_files = this.lSop.files.length
        }
        if (idx > -1) {
          Object.assign(this.sopList[idx], this.lSop)
        }
      } else {
        this.sopList.push({
          cl_item: this.lSop.cl_item,
          tot_files: 0
        })
      }
      this.showEditChecklist = false
    },
    loadChecklist (curPpmId) {
      var qry = {
        params: {
          ppm_id: curPpmId
        }
      }
      this.sopList = []
      this.axios.get(config.API_URL + '/getSOPChecklistByPpmId/', qry)
      .then(response => {
        this.sopList = response.data
        var count = 1
        this.sopList.forEach(rec => {
          rec.updated_by = config.USER_ID
          this.loadSOPAttachment(rec)
          rec.sr_no = count
          count++
        })
        this.sopList.ppm_id = curPpmId
        this.sopList.not_ok = this.sopList.filter(rec => rec.cl_result === 'NOT OK').length
        this.sopList.ok = this.sopList.filter(rec => rec.cl_result === 'OK').length
        this.sopList.compChecklist = this.sopList.filter(rec => rec.cl_result !== '').length
      })
      .catch(err => {
        this.sopList = []
        this.msg(err, 0)
      })
    },
    prepareUpdateChecklist (curSop) {
      this.lSop = Object.assign({}, curSop)
      this.showEditChecklist = true
    },
    loadSOPAttachment (curSop) {
      var path = require('path')
      var qry = {
        params: {
          cl_id: curSop.cl_id
        }
      }
      curSop.files = []
      curSop.comm_id = config.COMM_ID
      this.axios.get(config.API_URL + '/getAttachmentByClId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          curSop.files.push({
            file_url: rec.file_url,
            file_name: path.basename(rec.file_url),
            is_selected: true,
            is_changed: false
          })
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    updateChecklist (curChecklist) {
      curChecklist.forEach(rec => {
        rec.updated_by = config.USER_ID
        rec.cl_result = rec.cl_result ? rec.cl_result : ''
      })
      this.axios.post(config.API_URL + '/sopChecklist/' + curChecklist.ppm_id, curChecklist)
      .then(response => {
        setTimeout(() => {
          this.loadChecklist(curChecklist.ppm_id)
        }, 1000)
        this.$forceUpdate()
        this.showCheckListDlg = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deleteChecklist (curChecklist) {
      if (!confirm('Sure, you want to delete the checklist item "' + curChecklist.cl_item + '"?')) {
        return
      }
      this.sopList.ppm_id = curChecklist.ppm_id
      var idx = this.sopList.findIndex(rec => this.lAction === 'update' && rec.cl_id === curChecklist.cl_id || this.lAction === 'create' && rec.cl_item === curChecklist.cl_item)
      if (idx > -1) {
        this.sopList.splice(idx, 1)
      }
    },
    prepareUploadFile (curSop) {
      this.lSop = Object.assign({}, curSop)
      this.showEditChecklist = true
      this.lSubAction = 'attach'
    },
    LoadImages (curSop) {
      this.sopFiles = Object.assign({}, curSop)
      this.showSopImages = true
    },
    dragElement () {
      let table = document.querySelector('.tblSopChecklist tbody')
      const self = this
      Sortable.create(table, {
        handle: '.handle',
        onEnd ({ newIndex, oldIndex }) {
          const rowSelected = self.sopList.splice(oldIndex, 1)[0]
          self.sopList.splice(newIndex, 0, rowSelected)
          self.sopList[newIndex].cl_order = newIndex
          self.sopList[newIndex].oldIndex = oldIndex
          self.sopList[newIndex].comm_id = config.COMM_ID
          self.saveChecklistIndex(self.sopList[newIndex])
        }
      })
    },
    saveChecklistIndex (curCheckList) {
      this.axios.post(config.API_URL + '/sopChecklistIndex/', curCheckList)
      .then(response => {
        setTimeout(() => {
          this.loadChecklist(curCheckList.ppm_id)
        }, 1000)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareSopChecklistTimeLine () {
      var qry = {
        params: {
          ppm_id: this.sopList.ppm_id
        }
      }
      this.axios.get(config.API_URL + '/getSopChecklistDetails/', qry)
      .then(response => {
        this.lChecklistDetails = response.data
        this.showTimeline = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpload () {
      this.showChecklistUpload = true
      this.lMAction = 'upload'
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lMAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    cancelChanges () {
      this.showChecklistUpload = false
    },
    async uploadSopChecklist () {
      // create checklist one by one
      this.readyForLoad = true
      this.loadInProgress = true
      for (var i = 0; i < this.recsLoaded.length; i++) {
        if (!this.recsLoaded[i].error) { // process only valid records
          // create record
          this.sopList.push({
            cl_item: this.recsLoaded[i].cl_item,
            cl_result: '',
            tot_files: 0
          })
          this.totLoaded++
        } else {
          this.totFail++
        }
      } // for every record
      this.sopList.not_ok = this.sopList.filter(rec => rec.cl_result === 'NOT OK').length
      this.sopList.ok = this.sopList.filter(rec => rec.cl_result === 'OK').length
      this.sopList.compChecklist = this.sopList.filter(rec => rec.cl_result !== '').length
      this.loadInProgress = false
      this.showChecklistUpload = false
      this.$forceUpdate()
    },
    loadServiceHistory (curPpm) {
      this.showSerHist = true
      this.loadServiceHist(curPpm)
      this.lSHAction = 'view'
      this.assetDet = {
        asset_id: curPpm.asset_id,
        asset_cat: curPpm.asset_cat,
        asset_name: curPpm.asset_name
      }
    },
    loadServiceHist (curAsset) {
      var qry = {
        params: {
          asset_id: curAsset.asset_id
        }
      }
      // available Category
      this.axios.get(config.API_URL + '/getServiceHistByAssetId/', qry)
      .then(response => {
        this.histList = response.data
        this.loadVendorList()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    prepareCreateServiceHist (curAsset) {
      this.lHist = {
        service_hist_dt: this.today,
        service_hist_desc: '',
        service_hist_cost: '',
        vendor_id: null,
        next_service_due_dt: null,
        asset_id: curAsset.asset_id,
        comm_id: config.COMM_ID
      }
      this.lSHAction = 'create'
      this.loadVendorList()
    },
    cancelChangesServHist () {
      this.lSHAction = 'view'
    },
    findVendor (curObject) {
      if (curObject.vendor_name) {
        var idx = this.vendors.findIndex(rec => rec.vendor_name === curObject.vendor_name)
        if (idx >= 0) {
          curObject.vendor_id = this.vendors[idx].vendor_id
        } else {
          curObject.vendor_id = null
          this.msg('Entered vendor is not found, it will be created newly', 2)
        }
      } else {
        curObject.vendor_id = null
      }
    },
    prepareEditHist (curAsset) {
      this.lHist = Object.assign({}, curAsset)
      this.lHist.service_hist_dt = handy.formatDBDate(curAsset.service_hist_dt)
      this.lHist.next_service_due_dt = curAsset.next_service_due_dt ? handy.formatDBDate(curAsset.next_service_due_dt) : null
      this.lHist.vendor_name = curAsset.vendor_id ? this.vendors.filter(rec => rec.vendor_id === this.lHist.vendor_id)[0].vendor_name : ''
      this.lSHAction = 'update'
    },
    saveServiceHistory (action) {
      if (!this.$refs.shForm.validate()) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/assetService/' + action, this.lHist)
      .then(response => {
        // refresh the Asset list
        this.loadServiceHist(this.lHist)
        this.lSHAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    deleteServiceHist (curHist) {
      if (!confirm('Sure, you want to delete the service histroy with date "' + curHist.service_hist_dt + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/assetService/delete', curHist)
      .then(response => {
        // refresh the list
        var idx = this.histList.findIndex(hist => hist.service_hist_id === curHist.service_hist_id)
        this.histList.splice(idx, 1)
        this.lSHAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareUploadPpmPlanner () {
      this.lAction = 'upload'
    },
    LoadKeyStaffIdList () {
      this.loadKeyStaffList()
      this.showKeyStaffIdList = true
    },
    LoadAssetDetailsList () {
      this.loadAssetList()
      this.showAssetDetailsList = true
    },
    validatePPMFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0
      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result
        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqPPMHeaders.length; i++) {
          if (headers[i] !== this.reqPPMHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        // Load the month list first before getting month index number
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            var tempStartMonth = ''
            var tempCat = ''
            for (var c = 0; c < this.colPPMNames.length; c++) {
              if (this.colPPMNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqPPMHeaders[c] + ' is empty; '
              } else {
                res[this.colPPMNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('').trim() : curRec[c].trim()
                var tempVal = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('').trim() : curRec[c].trim()
                if (this.reqPPMHeaders[c].toUpperCase() === 'CATEGORY') {
                  // tempCat is used in below validations
                  tempCat = tempVal
                  if (tempVal !== 'EQ' && tempVal !== 'NE') {
                    res['error'] += this.reqPPMHeaders[c] + ' - Invalid Category value. Enter only "EQ" or "NE"; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'NON-EQUIPMENT NAME') {
                  if (tempCat === 'NE' && (tempVal.trim() === '-' || tempVal.trim() === '')) {
                    res['error'] += this.reqPPMHeaders[c] + ' - Invalid value. Enter valid name; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'ASSET ID') {
                  if (tempCat === 'EQ' && (!/^[0-9]+$/.test(tempVal))) {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter only Numeric value; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'PPM TITLE') {
                  if (tempVal.trim() === '' || tempVal.trim() === '-' || tempVal.length <= 10) {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter minimum 10 charaters; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'FREQUENCY') {
                  if (tempVal.trim() !== 'S' && tempVal.trim() !== 'W' && tempVal.trim() !== 'BW' && tempVal.trim() !== 'M' && tempVal.trim() !== 'BM' && tempVal.trim() !== 'Q' && tempVal.trim() !== 'HY' && tempVal.trim() !== 'Y') {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter any of "S, W, BW, M, BM, Q, HY, Y"; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'STARTING FROM') {
                  var tempIndex = this.monthList.indexOf(tempVal)
                  // tempStartMonth is used in below validations
                  tempStartMonth = tempVal
                  if (tempVal.trim() === '' || tempVal.trim() === '-' || tempIndex === -1) {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter month as Jan, Feb, Mar ....; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'SCHEDULED DATE') {
                  var tempDt = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('').trim() : curRec[c].trim()
                  var schDate = new Date(tempDt)
                  // if it is valid date, this getDate will return day of the date. Else date is not in expected format.
                  if (schDate.getDate()) {
                    var startMonthIndex = this.monthList.indexOf(tempStartMonth)
                    if (schDate.getMonth() !== startMonthIndex) {
                      res['error'] += this.reqPPMHeaders[c] + ' - Starting from Month and Schedule date month are not matching; '
                    }
                  } else {
                    res['error'] += this.reqPPMHeaders[c] + ' - Invalid Date format. Format expected "yyyy-mm-dd"; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'NO OF YEARS') {
                  if (!/^[0-9]+$/.test(tempVal)) {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter 1 or 2 or 3 ; '
                  } else {
                    if (tempVal < 1 || tempVal > 3) {
                      res['error'] += this.reqPPMHeaders[c] + ' - is out of range. Enter 1 or 2 or 3 only; '
                    }
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'KEY STAFF ID') {
                  if (!/^[0-9]+$/.test(tempVal)) {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter only Numeric value; '
                  }
                } else if (this.reqPPMHeaders[c].toUpperCase() === 'IN-HOUSE ACTIVITY?') {
                  if (tempVal.trim().toUpperCase() !== 'YES' && tempVal.trim().toUpperCase() !== 'NO') {
                    res['error'] += this.reqPPMHeaders[c] + ' - is Invalid. Enter "Yes" or "No" only; '
                  }
                }
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadPPMPlanner () {
      // create ppm one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      // var tmpDt = null
      for (var a = 0; a < this.recsLoaded.length; a++) {
        curRec = this.recsLoaded[a]
        var startingMonth = (this.monthList.indexOf(handy.startWithUpper(curRec.starting_month)))
        if (!this.recsLoaded[a].error) { // process only valid records
          // fill-in gaps
          curRec.comm_id = config.COMM_ID
          // Declarations and initial setup
          var calendarYear = new Date(curRec.sched_dt).getFullYear()
          var calendarRunningYear = calendarYear
          var startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarYear, startingMonth, 1)))
          var scheduleDay = new Date(curRec.sched_dt).getDate()
          var scheduleMonth = new Date(curRec.sched_dt).getMonth()
          var scheduleDate = new Date(curRec.sched_dt)
          var totMonths = curRec.noofyears * 12
          var processYearNo = 1
          var runningMonth = startingMonth
          var totWeeks = curRec.noofyears * 53
          var schDateForWBW = new Date(curRec.sched_dt)
          if (curRec.starting_month) {
            // startingWeek = parseInt(handy.getWeekOfTheYear(new Date(this.calViewPeriod.getFullYear(), startingMonth, 1)))
            // var endingWeek = handy.getWeekOfTheYear(new Date(this.calViewPeriod.getFullYear(), 12, 0))
            curRec.ppm_week = []
            if (curRec.freq === 'S') {
              schDateForWBW = new Date(curRec.sched_dt)
              var WBWYear = new Date(schDateForWBW).getFullYear()
              var WBWMonth = new Date(schDateForWBW).getMonth()
              var WBWDay = new Date(schDateForWBW).getDate()
              var weekNo = parseInt(handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay)))
              var yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
              if (weekNo === 53 && yearNo < calendarRunningYear) {
                weekNo = 1
                yearNo = yearNo + 1
              }
              curRec.ppm_week.push({
                week: weekNo,
                week_year: yearNo,
                start_date: handy.getDateOfWeek(weekNo, yearNo),
                ppm_sch_status: 'Scheduled',
                ppm_sch_date: handy.formatDBDate(schDateForWBW)
              })
            } else if (curRec.freq === 'W') {
              for (var i = 0; i < totWeeks; i++) {
                if (i === 0) {
                  schDateForWBW = new Date(curRec.sched_dt)
                } else {
                  var schDateForProess = new Date(schDateForWBW)
                  schDateForWBW = (schDateForProess.setDate(schDateForProess.getDate() + 7))
                }
                WBWYear = new Date(schDateForWBW).getFullYear()
                WBWMonth = new Date(schDateForWBW).getMonth()
                WBWDay = new Date(schDateForWBW).getDate()
                weekNo = handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay))
                yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
                if (weekNo === 53 && yearNo < calendarRunningYear) {
                  weekNo = 1
                  yearNo = yearNo + 1
                }
                curRec.ppm_week.push({
                  week: weekNo,
                  week_year: yearNo,
                  start_date: handy.getDateOfWeek(weekNo, yearNo),
                  ppm_sch_status: 'Scheduled',
                  ppm_sch_date: handy.formatDBDate(schDateForWBW)
                })
              }
            } else if (curRec.freq === 'BW') {
              for (i = 0; i < totWeeks; i += 2) {
                if (i === 0) {
                  schDateForWBW = new Date(curRec.sched_dt)
                } else {
                  schDateForProess = new Date(schDateForWBW)
                  schDateForWBW = (schDateForProess.setDate(schDateForProess.getDate() + 14))
                }
                WBWYear = new Date(schDateForWBW).getFullYear()
                WBWMonth = new Date(schDateForWBW).getMonth()
                WBWDay = new Date(schDateForWBW).getDate()
                weekNo = parseInt(handy.getWeekNumber70(new Date(WBWYear, WBWMonth, WBWDay)))
                yearNo = handy.getWeekNumberOfYear70(new Date(WBWYear, WBWMonth, WBWDay))
                if (weekNo === 53 && yearNo < calendarRunningYear) {
                  weekNo = 1
                  yearNo = yearNo + 1
                }
                curRec.ppm_week.push({
                  week: weekNo,
                  start_date: handy.getDateOfWeek(weekNo, yearNo),
                  ppm_sch_status: 'Scheduled',
                  ppm_sch_date: handy.formatDBDate(schDateForWBW)
                })
              }
            } else if (curRec.freq === 'M') {
              for (i = 0; i < totMonths; i++) {
                calendarRunningYear = calendarYear + (processYearNo - 1)
                startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                this.pushSubsequentPPMSchedule(curRec.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                if (runningMonth === 11) {
                  processYearNo += 1
                  runningMonth = 0
                } else {
                  runningMonth += 1
                }
              }
            } else if (curRec.freq === 'BM') {
              for (i = 0; i < totMonths; i += 2) {
                calendarRunningYear = calendarYear + (processYearNo - 1)
                startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                this.pushSubsequentPPMSchedule(curRec.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                // If the runningMonth is 10 (means nov), it add the ppm entry for Nov (and next ppm entry for Jan of next year)
                // Hence increase the year and set month 0 for Jan entry.
                // If the runningMonth is 11 (means dec), it add the ppm entry for dec (and next ppm entry for Feb of next year)
                // Hence increase the year and set month 1 for Feb entry.
                if (runningMonth >= 10) {
                  // For Nov, Dec
                  processYearNo += 1
                  runningMonth = runningMonth - 10
                } else {
                  runningMonth += 2
                }
              }
            } else if (curRec.freq === 'Q') {
              for (i = 0; i < totMonths; i += 3) {
                calendarRunningYear = calendarYear + (processYearNo - 1)
                startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                this.pushSubsequentPPMSchedule(curRec.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                // If the runningMonth is 9 (means Oct), it add the ppm entry for Oct (and next ppm entry for Jan of next year)
                // Hence increase the year and set month 0 for Jan entry.
                // If the runningMonth is 10 (means Nov), it add the ppm entry for Nov (and next ppm entry for Feb of next year)
                // Hence increase the year and set month 1 for Feb entry.
                // If the runningMonth is 11 (means dec), it add the ppm entry for dec (and next ppm entry for Mar of next year)
                // Hence increase the year and set month 2 for Mar entry.
                if (runningMonth >= 9) {
                  // For Oct, Nov, Dec
                  processYearNo += 1
                  runningMonth = runningMonth - 9
                } else {
                  runningMonth += 3
                }
              }
            } else if (curRec.freq === 'HY') {
              for (i = 0; i < totMonths; i += 6) {
                calendarRunningYear = calendarYear + (processYearNo - 1)
                startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                this.pushSubsequentPPMSchedule(curRec.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                // If the runningMonth is 6 (means Jul), it add the ppm entry for Jul (and next ppm entry for Jan of next year)
                // Hence increase the year and set month 0 for Jan entry.
                // The same has been done for Aug, Sep, Oct, Nov, Dec
                if (runningMonth >= 6) {
                  // For Jul, Aug, Sep, Oct, Nov, Dec
                  processYearNo += 1
                  runningMonth = runningMonth - 6
                } else {
                  runningMonth += 6
                }
              }
            } else if (curRec.freq === 'Y') {
              for (i = 0; i < totMonths; i += 12) {
                calendarRunningYear = calendarYear + (processYearNo - 1)
                startingWeek = parseInt(handy.getWeekNumber70(new Date(calendarRunningYear, runningMonth, 1)))
                this.pushSubsequentPPMSchedule(curRec.ppm_week, runningMonth, calendarYear, calendarRunningYear, scheduleMonth, startingWeek, scheduleDay, scheduleDate)
                // Keep the runningmonth value unchanged and incrase processYearNo for each time
                processYearNo += 1
              }
            }
          }
          // create record
          await this.axios.post(config.API_URL + '/uploadPPMPlanner/', curRec)
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.msg('Uploaded successfully', 1)
        if (this.enableChip === 'Month') {
          setTimeout(() => {
            this.loadPpmList()
            this.eventsMap
          }, 1000)
        } else {
          setTimeout(() => {
            this.loadPpmList()
          }, 1000)
        }
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    },
    loadServiceHistLists () {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: config.COMM_ID,
          filterHist: this.filterHistList
        }
      }
      this.axios.get(config.API_URL + '/getServiceHistLists/', qry)
      .then(response => {
        this.serviceHist = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadDashboardBasedOnPeriod (curChip = this.selectedChip) {
      this.selectedChip = curChip
      this.fromDate = this.toDate = null
      var curDate = new Date()
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1))
        this.toDate = this.fromDate
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)))
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6))
      } else if (curChip === 'Last Month') {
        curDate.setDate(1)
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0)
      } else {
        if (this.lReport.to_dt < this.lReport.from_dt) {
          this.msg('From date has to be less than or equal to To date', 0)
          return
        }
        this.fromDate = new Date(this.lReport.from_dt)
        this.toDate = new Date(this.lReport.to_dt)
      }
      this.fromDate = handy.formatDBDate(this.fromDate)
      this.toDate = handy.formatDBDate(this.toDate)
      this.loadServiceHistLists()
    },
    prepareSerHistFilter () {
      this.showSerHistFilter = true
      this.loadVendorList()
      this.loadAssetCategory()
    },
    getEmptyFilterHist () {
      var filterHist = {
        asset_name: '',
        asset_cat_list: [],
        asset_tag: '',
        vendor_list: []
      }
      return filterHist
    },
    applyHistFilter () {
      if (this.filterHistList.asset_name || this.filterHistList.asset_tag || this.filterHistList.asset_cat_list && this.filterHistList.asset_cat_list.length || this.filterHistList.vendor_list.length && this.filterHistList.vendor_list) {
        this.enabledHistFilter = true
      }
      this.showSerHistFilter = false
      this.loadServiceHistLists()
      this.$forceUpdate()
    },
    clearHistFilter () {
      this.filterHistList.asset_tag = ''
      this.filterHistList.asset_name = ''
      this.filterHistList.asset_cat_list = []
      this.loadServiceHistLists()
      this.enabledHistFilter = false
      this.showSerHistFilter = false
      this.$forceUpdate()
    },
    downloadAsPdf () {
      // pdf options
      var commName = config.COMM_NAME
      let opt = {
        margin: [20, 13, 13, 13],
        filename: 'PpmPlanner.pdf',
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, dpi: 120, letterRendering: true, height: 1300 },
        jsPDF: { format: 'letter', orientation: 'landscape' }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf().from(canvas).set(opt).toPdf().get('pdf').then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages(opt.jsPDF)
        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.text(commName, 130, 20)
          pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 25, pdf.internal.pageSize.getHeight() - 5)
        }
      }).save()
    },
    viewServiceHistRep () {
      this.lRAction = 'viewServiceHist'
    },
    loadPpmListBasedOnPeriod (curChip = this.selectedChipForPpm) {
      this.selectedChipForPpm = curChip
      this.fromDate = this.toDate = null
      var curDate = new Date()
      if (curChip === 'Today') {
        this.fromDate = this.toDate = curDate
      } else if (curChip === 'Yesterday') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 1))
        this.toDate = this.fromDate
      } else if (curChip === 'Last Week') {
        this.fromDate = new Date(curDate.setDate(curDate.getDate() - 7 - (curDate.getDay() - 1)))
        this.toDate = new Date(curDate.setDate(curDate.getDate() + 6))
      } else if (curChip === 'Last Month') {
        curDate.setDate(1)
        this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
        this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0)
      } else {
        if (this.lPpmRep.to_dt < this.lPpmRep.from_dt) {
          this.msg('From date has to be less than or equal to To date', 0)
          return
        }
        this.fromDate = new Date(this.lPpmRep.from_dt)
        this.toDate = new Date(this.lPpmRep.to_dt)
      }
      this.fromDate = handy.formatDBDate(this.fromDate)
      this.toDate = handy.formatDBDate(this.toDate)
      this.loadPpmListsBasedOnChip()
    },
    viewPpmSummary () {
      this.lRAction = 'viewPpmSum'
    },
    loadPpmListsBasedOnChip () {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getPpmListsBasedOnCommId/', qry)
      .then(response => {
        this.ppmList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadHistoryBasedOnAssetId (curRec) {
      this.serviceHistDet = curRec
      this.serviceHistBasedOnAsset = curRec.service_hist_list
      this.showServiceHistDet = true
    }
  }
}
</script>

<style>
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// PpmPlanner.vue?6c79ddae